import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject, ViewChild, NgZone, OnChanges, AfterViewInit, ElementRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
// parent component
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take, catchError } from 'rxjs/operators';

// services
import { BookingService } from '../../services/booking.service';
import { MilesAndMore } from '../../services/miles-n-more.service';
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { PriceService } from '../../services/price.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { CopyService } from '../../../shared/services/app-copy.service';
import { AirportCopyService } from '../../../shared/services/app-airport-copy.service';
import { ValidationService } from '../../services/validation.service';
import { AppLoaderService } from '../../../shared/services/app-loader.service';
import { LoginService } from '../../../shared/services/login.service';
import { EventsService } from '../../services/events.service';
import { SharedService } from '../../../shared/services/shared-service.service';
import { AppStateService } from '../../../shared/services/app-state.service';
import { BagItemsService } from '../../../shared/services/bagItems.service';
import { ExternalScriptsService } from '../../../shared/services/external-scripts.service';
import { ApplePayService } from '../../../booking/services/apple-pay.service';
import { ExponeaBannerService } from '../../../shared/services/exponea-banner.service';
// models
import { AppState } from '../../models/app-state.interface';
import { ModalData } from '../../../shared/models/modal.interface';
import { LoadingStatus } from '../../../shared/models/app-loader.interface';
import { CardData } from '../../models/card-data.interface';
import { BookingInitState } from '../../models/booking-reducer.interface';
import { MilesRangeRequest } from '../../models/miles-and-more';
import { UserInitState } from '../../../shared/models/user-reducer.interface';
import { PaymentRequest } from '../../models/payment-request.interface';

import { bookingKeyStart, bookingKey } from '../../shared/variables';

import moment from 'moment';
import { BillingAddress } from 'app/booking/models/payment.interface';
import { COUNTRY_CODES, MILES_LOGIN_URL } from '../../../shared/globals';
import { NgForm } from '@angular/forms';

declare var ga: any;
declare var adyen: any;
declare var ThreedDS2Utils: any;
declare var fbq: any;
declare var exponea: any;
declare var ApplePaySession: any;
declare var google: any;

let bookingPriceData = '';
let currencyCode = 'GBP';
let countryCode = 'GB'
const cardTypes = {
  '2': 'Mastercard',
  '5': 'Mastercard',
  '3': 'American Express',
  '4': 'Visa',
  '6': 'Discover',
}

export function buildPaymentTokenFields(
  paymenttype: number,
  data: { googlePayData: any; applePayData: any }
): { googlePayToken: string; applePayToken: string } {
  if (paymenttype === 0 && data.googlePayData) {
    return {
      googlePayToken: data.googlePayData.paymentMethodData.tokenizationData.token,
      applePayToken: ''
    };
  }

  if (paymenttype === 1 && data.applePayData) {
    return {
      googlePayToken: '',
      applePayToken: JSON.stringify(data.applePayData.token.paymentData)
    };
  }

  // PayPal (paymenttype === 3) carries no client-side token - the ADD_BOOKING
  // request signals PayPal via paymenttype alone (see callApi()'s
  // PaymentRequest.paymenttype), and the backend performs the Adyen
  // authorization + any redirect entirely server-side.
  return { googlePayToken: '', applePayToken: '' };
}

@Component({
  selector: 'app-step-payment',
  templateUrl: './step-payment.component.html',
  styleUrls: ['./step-payment.component.scss'],
  providers: [DataStorageService, ValidationService]
})
export class StepPaymentComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {

  @ViewChild('bookerForm') bookerForm;
  @ViewChild('standardPaymentForm') standardPaymentForm;
  @ViewChild('recurringPaymentForm') recurringPaymentForm;
  @ViewChild('termsForm') termsForm;
  @ViewChild('termsFormExpresscheckout') termsFormExpresscheckout: NgForm;
  @ViewChild('threeDS2Form') threeDS2Form;
  @ViewChild('threeDs1Form') threeDs1Form;
  @ViewChild('formBillingAddress') formBillingAddress;
  @ViewChild('applePay') applePayForm;

  public applePaySdk: Promise<any>;
  public paymentOptionsAvailable = {
    card: true,
    gpay: true,
    apple: false,
    paypal: false
  }; // 2 for apple pay testing

  private _bookingInitSubscription: Subscription;
  private _amendBookingCallSub: Subscription;
  private _userSubscription: Subscription;
  private _priceSubscription: Subscription;
  private _bookingStateSubscription: Subscription;
  private _validatePhoneNumberSubscription: Subscription;
  private _cardDeletedSubscription: Subscription;
  private _updatedUserSubscription: Subscription;
  private _userLoggedInSubscription: Subscription;
  private _userLoggedOutSubscription: Subscription;
  private _loaderSubscription: Subscription;
  private _cardDeletedRequestSentSubscription: Subscription;
  private _threeDS2Subscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _d2dBookingSubscription: Subscription;
  private _upsellBookingSubscription: Subscription;
  private _applePaymentSubmitSubscription: Subscription;
  private _paypalPopupAbandonedSubscription: Subscription;
  private _milesStateSubscription$: Subscription;
  private _priceStatusSubscription$: Subscription;
  private _milesSubscription: Subscription;
  private _flybackReducerSubscription: Subscription;
  private _verifyEmailSubscription: Subscription;

  private _bookingCarrier;
  private _bookingJourneyReference;
  private _promoDiscount;
  private _promoActive: Boolean = false;
  private _gaPromoEvent;
  private _useSavedCard = false;
  private _saveCard = false;
  private _recurringReference = '';
  private _savedCardDetails = null;
  private _dt;
  private _cardData: CardData = {
    number: '',
    cvc: '',
    generationtime: '',
    expiryMonth: '',
    expiryYear: '',
    holderName: ''
  };
  private _encryptedData;
  private _keyStart: string = environment.bookingKeyStart;
  private _key: string = this._keyStart + environment.bookingKey;
  private _options: Object = {};
  private _maskedNumber = '';
  private _googlePayMaskNumber = '';
  private _googlePayData: any;
  private _applePayData: any = null;
  private _googlePayToken = '';
  private _applePayToken = '';
  private _transactionType = 'New';
  private _businessTransactionType = 'NewBusiness';
  private _bookingCompleteFlag = false;
  private _sendGAPageview = true;
  private _latestFlight;
  private _firstLoad = true;
  private _priceHistoryMinor = null;
  private _threedsContainer;
  private _threedsIframe;
  private paymentEventFired = false;
  private milesUserDataLoaded = true;
  private _customerLocationCoord = null;

  public flightDirection;
  public countryCodes = COUNTRY_CODES.all;
  public bookingInit: Boolean = false;
  public pricingInit: Boolean = false;
  public copyLoaded: Boolean = false;
  public appCopy;
  public appAirportCopy;
  public currentBooking;
  public bookingState: BookingInitState;
  public user: UserInitState;
  public userDetails;
  public disableBook: Boolean = false;
  public phoneNumberValid = true;
  public userRole;
  public eligibleForInvoice: Boolean = false;
  public showInvoice: Boolean = false;
  public payByInvoice: Boolean = false;
  public showOverridePayment = false;
  public overridePayment = false;
  public price;
  public oldprice: any;
  public oldPriceMessage: any;
  public priceValidation: any;
  public isVisible: boolean = false;
  public virtualBags = null;
  public userHasCards = false;
  public userCards = null;
  public selectedCard;
  public selectedCardItem;
  public selectedPaymentMethod: 'paypal' | 'card' = null;
  public bookingAmendSection;
  public bookingType;
  public showAmendLoader = false;
  public hasPriceDifference = false;
  public priceDifferenceAmout = 0;
  public bookingProduct;
  public togglePromo = false;
  public priceHistoryMajor = null;
  public flightCodeNumber: any;
  public paymenttype: any = 2; // 0 = google Pay, 1 = Apple Pay, 2 = Card payment, 3 = PayPal
  public ccdCheckbox: boolean;
  public showLoader: Boolean = false;
  private _stateSubscription: Subscription;
  public billingAddress: BillingAddress = null;
  public isCustomerSupport = false;
  public billingAddressValid = true;
  public showThreeDS2Form = true;
  public isFailedPayment = false;
  public threeDS2Data = {
    request: '',
    postURL: '',
    originURL: '',
    type: ''
  };
  public threeDs1Data = {
    md: '',
    pReq: '',
    termUrl: '',
    issueUrl: '',
    notificationUrl: ''
  }
  // Set once a submit actually reaches the payment API, so the wrapper in
  // handlePaymentSubmit()/handlePaymentAmend() can tell "aborted at a
  // validation guard" (close the popup) from "in flight" (keep it open).
  private _paypalRedirectPopupInFlight = false;
  public threeDsPaymentType = '';
  public showChallengeShopper = false;
  public selectedLanguage = '';
  public languageCode = '';
  public premiumSurcharge;
  public customsInspection = false;
  public emiratesSkywards = false;
  public upsellFormData = { set: true, data: null };
  public totalD2dPrice: any = 0;
  public isD2dService = false;
  public canDoMilesLogin = false;
  public milesLoaded: LoadingStatus = 'idle';
  public callbackURL = location ? location.href.split('?')[0] : '';
  public milesLoginUrl = MILES_LOGIN_URL;
  public milesReducer = null;
  public bookingAmendType = 'none';
  public env = environment.envName;
  public cutOffTimeWindowDate: any;
  public cutOffTimeWindowTime: any;
  public amendCutOffTimeWindowDate: any;
  public amendCutOffTimeWindowTime: any;
  public collectionDiff: number;
  public bookingAirportName: string;
  public bookingAirlineName: string;
  public paymentData: any;
  public saveDMilesServiceCard = '';
  public milesServiceCardPattern = /^\d{15}$/;
  public screenSize: number;
  public hasSmsMarketingEnrolmentForExpressCheckout = true;
  public showHasSmsMarketingEnrolmentForExpressCheckout = false;
  public customerOptIn = false;

  constructor(
    private _appStore: Store<AppState>,
    private _bookingService: BookingService,
    private _dataStorageService: DataStorageService,
    private _pricingService: PriceService,
    private _copyService: CopyService,
    private _airportCopyService: AirportCopyService,
    private _validationService: ValidationService,
    private _errorService: ErrorHandler,
    private _appLoaderService: AppLoaderService,
    private _loginService: LoginService,
    private _eventsService: EventsService,
    private _bagItemsService: BagItemsService,
    private _zone: NgZone,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _sharedService: SharedService,
    private _appStateService: AppStateService,
    private _externalScriptsService: ExternalScriptsService,
    private _applePayService: ApplePayService,
    private _http: HttpClient,
    private _milesAndMoreService: MilesAndMore,
    private _exponeaBanner: ExponeaBannerService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

  }

  ngOnInit() {
    const state = this.getState(this._appStore);
    const flybackReducer = state.flybackReducer
    const flyBackRedirect = flybackReducer.flyBackRedirect;
    if (flyBackRedirect) {
      this._appLoaderService.hideLoader();
    }


    if (isPlatformBrowser(this.platformId)) {
      this.screenSize = window.innerWidth;
    }

    if (this._activatedRoute.snapshot.queryParams.d2d === 'falseD2D') {
      this._appStore.dispatch({ type: 'UPDATE_D2D_SERVICE', payload: false });
      this._dataStorageService.saveData()
    }

    this.bookingAmendType = this.getState(this._appStore).bookingReducer.bookingDetails.bookingAmendType;
    this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        // if booking data has bookingLoaded
        // show template and subscribe to data
        if (res.currentBookingLoaded && res.copyLoaded && res.userLoaded && !this.paymentEventFired) {
          this.paymentEventFired = true;
          const state = this.getState(this._appStore);
          exponea.track('oldfunnel_payment', {
            logged_in: state.userReducer.userDetails.userLoggedIn,
            email: state.userReducer.userDetails.userEmail,
            entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
          });

          setTimeout(() => {
            this._dataStorageService.saveData();
          }, 0);

          let collectionDateTimeUTC = moment(state.currentBookingReducer.currentBooking.bookingJourney[0].collectionDateTimeUTC);
          if (this.getState(this._appStore).bookingReducer.bookingDetails.bookingProduct === 'ccd') {
            const requestedDateTime = this.getState(this._appStore).flightReducer.flightDetails.flightResponse.flightInfo.requestedDateTime;
            collectionDateTimeUTC = moment(requestedDateTime);
          }

          const cutOffTimeWindow = state.timeslotReducer.cutOffTimeWindow; // 720 minutes
          const amendCutOffTimeWindow = state.timeslotReducer.amendCutOffTimeWindow; // 120 minutes

          const dateToModify = moment(collectionDateTimeUTC);
          const diff = dateToModify.subtract(cutOffTimeWindow, "minutes").toDate();

          const dateToModify2 = moment(collectionDateTimeUTC);
          const amendDiff = dateToModify2.subtract(amendCutOffTimeWindow, "minutes").toDate();

          this.cutOffTimeWindowDate = moment(diff);
          this.cutOffTimeWindowTime = moment(diff);

          this.amendCutOffTimeWindowDate = moment(amendDiff);
          this.amendCutOffTimeWindowTime = moment(amendDiff);

          const currentDate = moment().set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
          })

          this.collectionDiff = collectionDateTimeUTC.diff(currentDate, 'hour');

        }

        if (res.currentBookingLoaded && res.copyLoaded && res.airportCopyLoaded && this._firstLoad) {
          const bookingType = this.getState(this._appStore).bookingReducer.bookingDetails.bookingType;
          const bookingAmendType = this.getState(this._appStore).bookingReducer.bookingDetails.bookingAmendType;
          const bookingAmendSection = this.getState(this._appStore).bookingReducer.bookingDetails.bookingAmendSection;
          const amendUserCards = this.getState(this._appStore).userReducer.userDetails.amendUserCards;
          const bookingFlightDateAmend = this.getState(this._appStore).bookingReducer.bookingDetails.bookingFlightDateAmend;

          this._firstLoad = false;
          this.bookingInit = res.currentBookingLoaded;
          this.copyLoaded = res.copyLoaded;

          if (bookingType === 'amend' && bookingAmendType === 'refund') {
            this.paymentOptionsAvailable.gpay = false;
            this.paymentOptionsAvailable.apple = false;
            this.paymentOptionsAvailable.paypal = false;
            this.resetPaypalSelectionIfUnavailable();
          }

          // if user has redirected back from miles and more with transaction id
          // and status we need to wait for user to load
          if (bookingType === 'amend' && bookingAmendSection !== 'booker') {
            this._appStore.dispatch({ type: 'UPDATE_BOOKING_AMEND_SECTION', payload: 'payment' });
          }
          const qParams = this._activatedRoute.snapshot.queryParams;
          if (bookingType === 'amend' && ((qParams.id && qParams.status) || qParams.code)) {
            this._firstLoad = true;
            this.milesUserDataLoaded = false;
            if (res.userLoaded && res.priceLoaded) {
              this.milesUserDataLoaded = true;
              this._firstLoad = false;
            }
          }
          // if amend and user doesn't have amend cards, cancel amend
          if (this.milesUserDataLoaded) {
            const state = this.getState(this._appStore).userReducer.userDetails;
            if (bookingType === 'amend' && !amendUserCards && !bookingFlightDateAmend) {
              this.currentBooking = this.getState(this._appStore).currentBookingReducer.currentBooking;

              const errorData = {
                text: 'There seems to be a problem fetching your payment details. Please try again.',
                sticky: true
              };
              this._errorService.handleCustomError(errorData);

              this.cancelAmend();
            } else {
              this.setDataSubscriptions();

              if (isPlatformBrowser(this.platformId)) {
                this.getAirportCopy();
                this.getCopy();
              }

              this._userLanguageSubscription = this._appStore.select('copyReducer')
                .subscribe((res: any) => {
                  this.selectedLanguage = res.language;
                  this.languageCode = res.languageCode;
                })
            }
          }
        } else {
          return;
        }
      });
    // // check if amend paymend refunded or taken
    this._amendBookingCallSub = this._appStore.select('priceReducer')
      .subscribe((res) => {
        if (res.amendPaymentConfirmed) {
          this._appStore.dispatch({ type: 'AMEND_PAYMENT_CONFIRMED', payload: false });
          this.handlePaymentAmend();
        }
      })
    // set user values on login and logout
    this._userLoggedInSubscription = this._loginService.userSubject$.subscribe(res => {
      this.setUserValues(this.getState(this._appStore).userReducer);
      this._appStore.dispatch({ type: 'UPDATE_MARKETING_ENROLMENT', payload: true });
    });
    this._userLoggedOutSubscription = this._loginService.userLoggedOut$.subscribe(res => {
      this.setUserValues(this.getState(this._appStore).userReducer);
    });
    this._verifyEmailSubscription = this._loginService.validateUserSubject$.subscribe(res => {
      this.hasSmsMarketingEnrolmentForExpressCheckout = true;
      this.showHasSmsMarketingEnrolmentForExpressCheckout = res.hasMarketingEnrolment;
      // this._appStore.dispatch({ type: 'UPDATE_OPTED_IN_VIA_BANNER', payload: res.hasMarketingEnrolment });
      this._appStore.dispatch({ type: 'UPDATE_MARKETING_ENROLMENT', payload: true });
      this.termsFormExpresscheckout.form.patchValue({
        hasSmsMarketingEnrolmentForExpress: true
      })
    });

    this._loaderSubscription = this._appLoaderService.loaderState$
      .subscribe(res => {
        if (res.show === false) {
          this.disableBook = false;

        }
      });

    // The customer closed the PayPal popup without paying.
    //
    // If the booking request is still in flight, keep the screen blocked and let
    // the response land first - releasing the button now would let them submit a
    // second booking while the first is mid-creation. openPaypalRedirectPopup()
    // shows the error when that response arrives.
    //
    // If the request had already come back (they were in PayPal), nothing else
    // is coming, so release the screen straight away.
    this._paypalPopupAbandonedSubscription = this._bookingService.paypalPopupAbandoned$
      .subscribe(res => {
        if (!res?.requestStillPending) {
          this.handlePaypalPopupAbandoned();
        }
      });

    this._applePaymentSubmitSubscription = this._applePayService.onPaymentSubmit$
      .subscribe(res => {
        if (res) {
          this.handleApplePayComplete();
        }
      });

    this.initializeApplePay();
  }

  initializeApplePay() {
    if (isPlatformBrowser(this.platformId)) {
      this.applePaySdk = new Promise((resolve) => {
        const options = {
          crossorigin: true,
          id: "apple-pay-js",
          src: "https://applepay.cdn-apple.com/jsapi/v1.1.0/apple-pay-sdk.js",
        };

        this._externalScriptsService.loadScript(options, () => {
          console.log("Apple pay sdk loaded");

          if (typeof ApplePaySession === "undefined") {
            this.hideApplePayButton();
          } else {
            this.displayApplePayButton();
          }
        });
        resolve(true);
      });
    }
  }

  displayApplePayButton() {
    console.log('Apple pay is available');
    this.paymentOptionsAvailable.apple = true;
  }

  hideApplePayButton() {
    console.log('Apple pay is not available');
    this.paymentOptionsAvailable.apple = false;
  }

  private resetPaypalSelectionIfUnavailable(): void {
    if (this.selectedPaymentMethod === 'paypal' && !this.paymentOptionsAvailable.paypal) {
      this.selectedPaymentMethod = 'card';
    }
  }

  selectPaymentMethod(method: 'paypal' | 'card'): void {
    this.selectedPaymentMethod = method;
  }


  getPaymentData() {
    const state = this.getState(this._appStore);
    let isD2dService = state.bookingReducer.bookingDetails.isD2dService;
    let total_price = isD2dService
      ? this.getD2dDiscountPrice()
      : this.price.totalPrice?.majorAmount ? this.price.totalPrice?.majorAmount.toFixed(2) : this.price.pricingResponse[0].pricingBreakdown.discountedTotalPriceMajor.toFixed(2); // new/failed payment
    if ((this.bookingState.bookingDetails.bookingAmendType === "refund" && this.bookingType === "amend")
      || (this.bookingState.bookingDetails.bookingAmendType === "payment" && this.bookingType === "amend")) {
      total_price = this.price.priceHistory.majorAmount; // for amend flow
    }

    bookingPriceData = total_price.toString();
    this.paymentRequest.transactionInfo.totalPrice = bookingPriceData;
  }

  googlePaymentData(paymentData) {
    this._bookingService.setGooglePaymentToken(paymentData);
    const state = this.getState(this._appStore);
    let isD2dService = state.bookingReducer.bookingDetails.isD2dService;
    let total_price = isD2dService
      ? this.getD2dDiscountPrice()
      : this.price.pricingResponse[0].pricingBreakdown.discountedTotalPriceMajor.toFixed(2); // new/failed payment
    if ((this.bookingState.bookingDetails.bookingAmendType === "refund" && this.bookingType === "amend")
      || (this.bookingState.bookingDetails.bookingAmendType === "payment" && this.bookingType === "amend")) {
      total_price = this.price.priceHistory.majorAmount; // for amend flow
    }
    this._bookingService.setOldPriceService(total_price.toString())

  }
  ngOnChanges(): void {

    /**********THIS FUNCTION WILL TRIGGER WHEN PARENT COMPONENT UPDATES 'price'**************/
    //Write your code here
    console.log(this.price, 'ngonchanges');
    this.getPaymentData();
    this.oldprice = this.price;

  }

  paymentRequest: google.payments.api.PaymentDataRequest = {
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [
      {
        type: 'CARD',
        parameters: {
          allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
          allowedCardNetworks: ['AMEX', 'VISA', 'MASTERCARD']
        },
        tokenizationSpecification: {
          type: 'PAYMENT_GATEWAY',
          parameters: {
            gateway: 'adyen',
            gatewayMerchantId: "PortrLtd",

          }
        }
      }
    ],
    merchantInfo: {
      merchantId: environment.gPayMerchantId,
      merchantName: environment.gPayMerchantName
    },
    emailRequired: true,
    shippingAddressRequired: true,
    shippingAddressParameters: {
      phoneNumberRequired: true,
      allowedCountryCodes: []
    },
    transactionInfo: {
      totalPriceStatus: 'FINAL',
      totalPriceLabel: 'Total',
      totalPrice: bookingPriceData,
      currencyCode: currencyCode,
      countryCode: countryCode
    },
    callbackIntents: ['PAYMENT_AUTHORIZATION'],
  };

  onLoadPaymentData = (
    event: Event
  ): void => {
    console.log('pay btn');

    const eventDetail = event as CustomEvent<google.payments.api.PaymentData>;
    this.googlePaymentData(eventDetail.detail);
  }



  onPaymentAuthorizedData: google.payments.api.PaymentAuthorizedHandler = (
    paymentData
  ) => {

    if (paymentData != null) {
      this.paymentData = paymentData;
      // this.sendBookerToRequest(this.bookerForm.bookerData);
      // if booking type is amend
      if (paymentData.paymentMethodData.tokenizationData.token) {
        this._bookingService.setGooglePaymentToken(paymentData);
      }
      this.recievePaymentType(0);
      if (this.bookingType === 'amend') {
        this.handlePaymentAmend();
      } else {
        this.handlePaymentOptionSubmit();
        // this.handlePaymentSubmit();
      }
    } else {
      this.showAmendLoader = false;
    }

    return {
      transactionState: 'SUCCESS'
    };
  }

  onPressButton = (event: Event): void => {
    const currentAppState = this.getState(this._appStore);
    currencyCode = currentAppState.timeslotReducer.currency.code;
    this.paymentRequest.transactionInfo.currencyCode = currencyCode;

    let total_price = this.isD2dService
      ? this.getD2dDiscountPrice()
      : this.price.totalPrice?.majorAmount ? this.price.totalPrice?.majorAmount.toFixed(2) : this.price.pricingResponse[0].pricingBreakdown.discountedTotalPriceMajor.toFixed(2); // new/failed payment
    if ((this.bookingState.bookingDetails.bookingAmendType === "refund" && this.bookingType === "amend")
      || (this.bookingState.bookingDetails.bookingAmendType === "payment" && this.bookingType === "amend")) {
      total_price = this.price.priceHistory.majorAmount; // for amend flow
    }
    this._bookingService.setOldPriceService(total_price.toString())
    // console.log(this.isPaymentFormValidate,'OpenSheet');
    const bookerFormHasError = typeof this.bookerForm.bookerData !== 'undefined';
    const formHasStandardForm = typeof this.standardPaymentForm !== 'undefined';
    const formHasRecurringForm = typeof this.recurringPaymentForm !== 'undefined';

    const termsForm = typeof this.termsFormExpresscheckout !== 'undefined';
    // if (formHasStandardForm && !this.standardPaymentForm.form.valid) {
    //   this._validationService.markFormDirty(this.standardPaymentForm.form);

    // }
    // if (formHasRecurringForm && !this.recurringPaymentForm.form.valid) {
    //   this._validationService.markFormDirty(this.recurringPaymentForm.form);

    // }
    if (termsForm && !this.termsFormExpresscheckout.form.valid) {
      this._validationService.markFormDirty(this.termsFormExpresscheckout.form);
    }
    if (this.bookingType !== 'amend') {
      if (!this.termsFormExpresscheckout.form.valid) {
        event.preventDefault();
      }
    }


  }


  onError = (event: ErrorEvent): void => {
    console.error('error', event.error);
  }

  recievePaymentType(value: number) {
    this.paymenttype = value;
    this._appStore.dispatch({ type: 'PAYMENT_TYPE', payload: value });
    this.logDisabledConditions(); // Log conditions when payment type changes
  }

  async setDataSubscriptions() {
    this.setCurrentStoreVars();
    // if hubdrop booking we need to generate new booking reference
    // to handle Miles and More booking referenc
    if (this.bookingType !== 'amend') {
      await this._bookingService.getBookingReferenceForRequest();
    }
    const state = this.getState(this._appStore);

    // threeDSIframe event
    window.addEventListener('message', (e) => this.handleThreeDSIframeEvent(e));

    // set init user values once on load
    this._userSubscription = this._appStore.select('userReducer')
      .pipe(take(1))
      .subscribe((user: UserInitState) => { this.setUserValues(user); });

    this._milesStateSubscription$ = this._milesAndMoreService.milesLoading$
      .subscribe(res => {
        this.milesLoaded = res;
      });

    this._priceStatusSubscription$ = this._pricingService.priceUpdating$
      .subscribe(isUpdating => {
        this.showLoader = isUpdating
      });

    this._priceSubscription = this._appStore.select('priceReducer')
      .subscribe((price: any) => {
        this._zone.run(() => {
          this.oldprice = this.price;
          this.price = price.price;
          if (Object.keys(this.price).length > 0) {
            // show error if user hasn't logged in
            if (this.price.validationErrorMessages !== null) {
              if (this.price.validationErrorMessages && this.price.validationErrorMessages[0].code === 702) {
                const errorData = {
                  text: this.price.validationErrorMessages[0].reasons[0],
                  sticky: false
                };
                this._errorService.handleCustomError(errorData);
                this._appStore.dispatch({ type: 'REMOVE_PROMO', payload: [] });
              }
            }

            this._promoDiscount = this.price.discountAppliedMinor;

            if (this.price.promoCodesApplied !== null) {
              this._promoActive = true;
            } else {
              this._promoActive = false;
              this._gaPromoEvent = true;
            }

            if (this.price.promoCodesApplied !== null && this._promoActive && this._gaPromoEvent) {
              this._gaPromoEvent = false;
              this.disableBook = false;
              ga('send', 'event', 'Promo Code Applied', this.price.promoCodesApplied[0]);
            }

            if (typeof this.price.priceHistory !== 'undefined') {
              this.hasPriceDifference = true;
              this.priceDifferenceAmout = this.price.priceHistory.majorPriceDifference;
              this._priceHistoryMinor = this.price.priceHistory.minorAmount;
              this.priceHistoryMajor = this.price.priceHistory.majorAmount;
              //for googlePay
              window['angularGooglePayComponentReference'] = {
                component: this, zone: this._zone,
                loadGooglePaymentFunction: (paymentData) => this.googlePaymentData(paymentData),
              };
              this.getPaymentData();
            }

            this.canDoMilesLogin = this.price.enableMilesLogin;
            const code = this._activatedRoute.snapshot.queryParams.code;
            if (code && !this.pricingInit) {
              let totalPrice = this.isD2dService ? this.getD2dDiscountPrice() * 100 : this.price.totalPrice.minorAmount;
              if (this.bookingType === 'amend') {
                totalPrice = this._priceHistoryMinor;
              }
              const request: MilesRangeRequest = {
                authCode: code,
                redirectUri: this.callbackURL,
                totalPrice: totalPrice,
                currency: price.price.totalPrice.currencyCode
              }
              this._milesAndMoreService.getMilesRange(request);
              this._router.navigate([], { replaceUrl: true, queryParams: {}, relativeTo: this._activatedRoute });
            }

            if (this.price.totalPrice.majorAmount === 0) {
              this.paymentOptionsAvailable.gpay = false;
              this.paymentOptionsAvailable.apple = false;
              this.paymentOptionsAvailable.paypal = false;
              this.resetPaypalSelectionIfUnavailable();
              // this.paymenttype = 1;
            } else {
              this.paymentOptionsAvailable.gpay = true;
              this.paymentOptionsAvailable.paypal = true;
              if (typeof ApplePaySession !== "undefined") {
                this.paymentOptionsAvailable.apple = true;
              }
            }
            this.pricingInit = true;
            this.getD2dDiscountPrice();
          }
        });
      });

    this._bookingStateSubscription = this._appStore.select('bookingReducer')
      .subscribe((bookingState: any) => {

        // if bags have been changed, get new prices
        if (this.virtualBags !== null && this.virtualBags !== bookingState.bookingDetails.virtualBagCount) {
          this.virtualBags = bookingState.bookingDetails.virtualBagCount;
          this._pricingService.updatePriceBags(this.virtualBags);
        } else {
          this.virtualBags = bookingState.bookingDetails.virtualBagCount;
        }
        this.premiumSurcharge = bookingState.bookingDetails.premiumSurcharge;
        this.isD2dService = bookingState.bookingDetails.isD2dService;
        this.customerOptIn = bookingState.bookingDetails.optedInViaBanner;
        if (state.d2dReducer.promoCode.length > 0) {
          this.togglePromo = true;
        }
      });

    this._milesSubscription = this._appStore.select('milesAndMoreReducer')
      .subscribe(miles => {
        this.milesReducer = miles;
      });

    this._validatePhoneNumberSubscription = this._bookingService.validPhoneNumberSubject$
      .subscribe(valid => {
        if (!valid) {
          this.bookerForm.form.controls['contactPhone'].setErrors({ 'incorrect': true });
          this.phoneNumberValid = false;
        } else {
          this.bookerForm.form.controls['contactPhone'].setErrors(null);
          this.phoneNumberValid = true;
        }
      });

    this._cardDeletedRequestSentSubscription = this._pricingService.cardRemovedRequestSent$
      .subscribe(res => {
        if (res) {
          this.disableBook = true;
        }
      });

    this._cardDeletedSubscription = this._pricingService.cardRemovedSubject$
      .subscribe(value => {
        if (value) {
          this._loginService.loginedUserDetails(this.userDetails.userToken);
        } else {
          this.disableBook = false;
        }
      });

    this._updatedUserSubscription = this._loginService.userIDSubject$
      .subscribe(res => {
        const newUserData = this.getState(this._appStore).userReducer;
        // this._appStore.dispatch({ type: 'UPDATE_MARKETING_ENROLMENT', payload: true });
        this.setUserValues(newUserData);
        this.disableBook = false;
      });

    this._threeDS2Subscription = this._appStore.select('threeDS2Reducer')
      .subscribe(res => {
        if (res.data.request !== '') {
          this.threeDS2Data = res.data;

          if (this.threeDS2Data.type === 'identify') {

            this._threedsContainer = document.getElementById('threedsContainer');
            const IFRAME_NAME = 'threeDSMethodIframe';
            this._threedsIframe = ThreedDS2Utils.createIframe(this._threedsContainer, IFRAME_NAME, '100%', '100%');
            const form = ThreedDS2Utils.createForm('threedsMethodForm', this.threeDS2Data.postURL, IFRAME_NAME, 'threeDSMethodData', this.threeDS2Data.request);

            this._threedsContainer.appendChild(form);
            setTimeout(() => {
              this._threedsContainer.removeChild(form);
            }, 1000);

            form.submit();
          } else if (this.threeDS2Data.type === 'challenge') {
            const IFRAME_NAME = 'threeDSChallengeIframe';
            const iframeSizesArr = ThreedDS2Utils.config.getChallengeWindowSize('05');

            this._threedsContainer = document.getElementById('threedsContainer');
            this._threedsIframe = ThreedDS2Utils.createIframe(this._threedsContainer, IFRAME_NAME, iframeSizesArr[0], iframeSizesArr[1]);
            const form = ThreedDS2Utils.createForm('cReqForm', this.threeDS2Data.postURL, IFRAME_NAME, 'creq', this.threeDS2Data.request);

            this._threedsContainer.appendChild(form);

            this.showChallengeShopper = true;
            this._appLoaderService.hideLoader();

            setTimeout(() => {
              this._threedsContainer.removeChild(form);
            }, 1000);

            form.submit();
          }
        } else if (
          (res.data.paymentSessionId && res.data.paymentSessionId !== '') ||
          // PayPal's RedirectShopper response carries no paymentSessionId /
          // paymentRequest / termUrl (those are 3DS1-only) - it only returns
          // issuerUrl, an Adyen checkoutPaymentRedirect link with all state
          // pre-encoded in its redirectData query param. Gating solely on
          // paymentSessionId would silently skip the PayPal redirect entirely.
          (res.data.isPaypal && res.data.issueUrl)
        ) {

          this.threeDs1Data.md = res.data.paymentSessionId;
          this.threeDs1Data.pReq = res.data.paymentRequest;
          this.threeDs1Data.issueUrl = res.data.issueUrl;
          this.threeDs1Data.termUrl = res.data.termUrl;
          this.threeDs1Data.notificationUrl = res.data.notificationUrl;

          if (res.data.isPaypal) {
            // PayPal's approval page won't allow iframe embedding (unlike a
            // bank ACS page), so this redirect opens in a popup window
            // instead of the hidden iframe used below.
            this.openPaypalRedirectPopup();

            this.showChallengeShopper = false;

            // Deliberately NOT hiding the loader: the payment is still in
            // progress in the popup, and this screen must stay blocked until it
            // reports back (mirroring the card 3DS paths, which keep their
            // challenge overlay up). hideLoader() also re-enables the submit
            // button via the loaderState$ subscriber, which would let the
            // customer re-submit a booking that already exists server-side.
            // The failure paths (popup closed, API error, missing redirect URL)
            // each hide it explicitly.
          } else {
            const IFRAME_NAME = 'threeDSRedirectIframe';
            const iframeSizesArr = ThreedDS2Utils.config.getChallengeWindowSize('05');

            this._threedsContainer = document.getElementById('threedsContainer');
            this._threedsIframe = ThreedDS2Utils.createIframe(this._threedsContainer, IFRAME_NAME, iframeSizesArr[0], iframeSizesArr[1]);
            const form = ThreedDS2Utils.createFormForRedirectShopper('RedirectShopperForm', this.threeDs1Data.issueUrl, IFRAME_NAME, 'PaReq', this.threeDs1Data.pReq, 'MD', this.threeDs1Data.md, "TermUrl", this.threeDs1Data.termUrl);
            this._threedsContainer.appendChild(form);

            this.showChallengeShopper = true;
            this._appLoaderService.hideLoader();

            setTimeout(() => {
              this._threedsContainer.removeChild(form);
            }, 1000);

            form.submit();
          }
        }
      });

    let flightReducer;

    this._stateSubscription = this._appStore.select('flightReducer').subscribe(res => {
      flightReducer = res;
      this.ccdCheckbox = res.flightDetails.flightProducts.ccd;
      this.iVerify(true);
    });
    const flightData = flightReducer.flightDetails.flightResponse.flightStatusDetails[0];
    if (flightData.airlineCode === 'AF' && flightData.departureAirport.airportCode === 'GVA' && flightReducer.flightDetails.flightProducts.abc) {
      this.customsInspection = true;
      this.customsForInspection(true)
    }
    this._appStore.dispatch({ type: 'UPDATE_CURRENT_BOOKING_PRODUCT', payload: this.bookingProduct });
    this._upsellBookingSubscription = this._bookingService.upsellBookingAdded$
      .subscribe(res => {
        const state = this.getState(this._appStore);
        if (res) {
          if (this.bookingProduct === 'abc') {
            // this._eventsService.generatePaths('ccd');
            // this._bookingService.updateBookingInstance(state.d2dReducer.inboundBooking.currentBookingReducer);
            // this._router.navigate(['/redirectingTo'],
            //   { queryParams: { redirectToPath: '/abc/payment', bookingProduct: 'abc' } });

            // setTimeout(() => {
            this._router.navigate(['/ccd/payment']);
            this._appStateService.setBookingStores(state.d2dReducer.inboundBooking);
            // }, 2000);

            // setTimeout(() => {
            //   this.handlePaymentSubmit();
            // }, 2500);

          } else {
            // this._eventsService.generatePaths('abc');
            // this._bookingService.updateBookingInstance(state.d2dReducer.outboundBooking.currentBookingReducer);
            // this._router.navigate(['/redirectingTo'],
            //   { queryParams: { redirectToPath: '/ccd/payment', bookingProduct: 'ccd' } });
            // setTimeout(() => {
            this._router.navigate(['/abc/payment']);
            this._appStateService.setBookingStores(state.d2dReducer.outboundBooking);
            // }, 2000);
          }
        }
      });

    if (flightData.airlineCode === 'EK') {
      this.emiratesSkywards = true;
      this.skywardsCheck(true);
    }

    // miles promtion
    if (this.getState(this._appStore).milesAndMoreReducer.isUserLoggedIn) {
      this._bookingService.setMilesPromotion(this._pricingService);
    }

    const bagParams = this._activatedRoute.snapshot.queryParams.bags;
    if (bagParams && !bagParams.serviceToRemove) {
      const bagItems = JSON.parse(bagParams);
      const totalBags = this._bagItemsService.getTotalItems(bagItems);
      this._appStateService.setBagItems({ ...bagItems });
      this._appStateService.setVirtualBags(totalBags);

      this._bookingService.updateBagItems({ ...bagItems });
      this._bookingService.updateVirtualBags(totalBags);

      this._router.navigate([], { replaceUrl: true, queryParams: {}, relativeTo: this._activatedRoute });
    }

    // if d2d booking and is primary booking set form data
    if (state.bookingReducer.bookingDetails.isD2dService && state.d2dReducer.addBookingCount === 1) {
      this.upsellFormData = { set: true, data: state.d2dReducer.formData };

      //
      this._appStore.dispatch({ type: 'HAS_CUSTOMS_AGREEMENT', payload: true });
      ga('send', 'event', 'Vanilla', 'Pay - Consent', 'Checked');
    }

    this._appStore.dispatch({ type: 'SAVE_SELECTED_TIMESLOT_DATE_TIME', payload: this.getState(this._appStore).timeslotReducer.selectedTimeslotDateTime });

    if (this._sendGAPageview) {
      this._sendGAPageview = false;
      if (this.currentBooking.bookingJourney[0].addOnProductType.length > 0) {
        if (this.bookingType !== 'amend') {
          ga('set', 'page', '/abc/payment/' + this._latestFlight);
          ga('send', 'pageview');
        } else if (this.bookingType === 'amend') {
          ga('set', 'page', '/a/abc/payment');
          ga('send', 'pageview');
        }
      } else {
        if (this.bookingType !== 'amend') {
          ga('set', 'page', '/sds/payment');
          ga('send', 'pageview');
        } else if (this.bookingType === 'amend') {
          ga('set', 'page', '/a/sds/payment');
          ga('send', 'pageview');
        }
      }
    }

  }

  getExpectMilesEarningAmount() {
    return Math.round(this.getD2dDiscountPrice());
  }

  saveMilesServiceCard(value) {
    const isValid = this.milesServiceCardPattern.test(value);
    if (!isValid) {
      return false;
    }
    this.saveDMilesServiceCard = value;
    this._appStore.dispatch({ type: 'ADD_MILES_SERVICE_CARD', payload: value });
  }

  removeMilesServiceCard() {
    this.saveDMilesServiceCard = '';
    this._appStore.dispatch({ type: 'ADD_MILES_SERVICE_CARD', payload: '' });
  }

  getD2dDiscountPrice() {
    const { totalD2dPrice } = this._bookingService.getD2dDiscountPrice(this.price);
    this.totalD2dPrice = totalD2dPrice;
    return this.totalD2dPrice;
  }

  setUserValues(u) {
    this.user = u;
    this.userDetails = this.user.userDetails;
    this.eligibleForInvoice = this.userDetails.currentUser.eligibleForInvoice;
    this.showInvoice = this.userDetails.userRole !== 'GUEST' && this.eligibleForInvoice && this.bookingType !== 'amend';
    this.showOverridePayment = this.bookingType === 'amend' && (this.userDetails.userRole === 'SUPERADMIN' || this.userDetails.userRole === 'ADMIN' || this.userDetails.userRole === 'CONCIERGE' || this.userDetails.userRole === 'EXTERNALAGENT');
    this.isCustomerSupport = this.getState(this._appStore).flightFinderReducer.csMotoFromUrl || this.userDetails.userPermissions.showAdminFeatures;
    // this.hasSmsMarketingEnrolmentForExpressCheckout = this.userDetails.hasMarketingEnrolment;

    // reset billing valid
    this.billingAddressValid = true;

    if (this.bookingType !== 'amend') {
      // if not amend - get cards from currentUser obj
      if (this.user.userDetails.currentUser.cardDetails === null
        || typeof this.user.userDetails.currentUser.cardDetails === 'undefined') {
        this.userHasCards = false;
      } else {
        this.userHasCards = true;
        this.userCards = this.userDetails.currentUser.cardDetails;
        this.selectedCard = 'card0';
        this.selectedCardItem = this.userDetails.currentUser.cardDetails[0].recurringDetailReference;
      }
    } else if (this.bookingType === 'amend') {
      // check user cards sent in getCompleteBookingRequest (amendUserCards)
      // saved in user reducer
      if (this.user.userDetails.amendUserCards === null || typeof this.user.userDetails.amendUserCards === 'undefined' || this.user.userDetails.amendUserCards.length === 0) {
        this.userHasCards = false;
      } else {
        this.userHasCards = true;
        this.userCards = this.userDetails.amendUserCards;
        this.selectedCard = 'card0';
        this.selectedCardItem = this.userDetails.amendUserCards[0].recurringDetailReference;
      }
    }

    this.applyDefaultPaymentMethodSelection();
  }

  private applyDefaultPaymentMethodSelection(): void {
    // On the second D2D booking the payment step re-initialises, but the
    // payment type chosen on the first booking is restored from d2dReducer
    // (see ngAfterViewInit). Keep the PayPal selection in step with it,
    // otherwise this reset would silently downgrade the auto-submitted
    // second booking to card.
    const d2dReducer = this.getState(this._appStore).d2dReducer;

    if (!this.isD2dAutoSubmitBooking()) {
      this.selectedPaymentMethod = this.bookingType === 'amend' ? 'card' : null;
      return;
    }

    this.selectedPaymentMethod = d2dReducer.paymentType === 3 ? 'paypal' : 'card';
  }

  setCurrentStoreVars() {
    const currentAppState = this.getState(this._appStore);
    // current booking store vars
    this.currentBooking = currentAppState.currentBookingReducer.currentBooking;
    // booking store vars
    this.bookingState = currentAppState.bookingReducer;
    this.bookingType = currentAppState.bookingReducer.bookingDetails.bookingType;
    this.bookingProduct = currentAppState.bookingReducer.bookingDetails.bookingProduct;
    this.flightDirection = currentAppState.bookingReducer.bookingDetails.journeyLegDetails[0].journeyDirection;
    this._bookingJourneyReference = currentAppState.bookingReducer.bookingDetails.bookingJourneyReference;
    this._bookingCarrier = this.bookingState.bookingDetails.carrier.airlineCode;
    this.bookingAmendSection = this.bookingState.bookingDetails.bookingAmendSection;
    this._latestFlight = currentAppState.flightReducer.flightDetails.flightResponse.flightStatusDetails[0].airlineCode;
    const flightDetails = currentAppState.flightReducer.flightDetails.flightResponse.flightStatusDetails;
    this.bookingAirportName = this.flightDirection === 1 ? flightDetails[0].departureAirport.airportName : flightDetails[flightDetails.length - 1].arrivalAirport.airportName;
    this.bookingAirlineName = flightDetails[0].airlineName
    this.saveDMilesServiceCard = currentAppState.milesAndMoreReducer.milesServiceCard;
    // should be tick by default
    // this.hasSmsMarketingEnrolmentForExpressCheckout = currentAppState.bookingReducer.bookingDetails.optedInViaBanner;
    // if collection/delivery address is residential, prefill billing address
    if (this.flightDirection === 1 && this.currentBooking.bookingJourney[0].collectionLocation.type === 4) {
      this.formatBillingAddress(this.currentBooking.bookingJourney[0].collectionLocation);
      this._customerLocationCoord = this.currentBooking.bookingJourney[0].collectionLocation.geoCoord;
    } else if (this.flightDirection === 2 && this.currentBooking.bookingJourney[0].deliveryLocation.type === 4) {
      this.formatBillingAddress(this.currentBooking.bookingJourney[0].deliveryLocation);
    }

    this.milesLoaded = currentAppState.milesAndMoreReducer.miles?.serviceCardNumber ? 'success' : 'idle';
    this.isFailedPayment = currentAppState.bookingReducer.bookingDetails.orignalAmendType === 'payment-required';

    const state = this.getState(this._appStore);
    if (state.bookingReducer.bookingDetails.promo.length > 0) {
      this.togglePromo = true;
    }
  }

  formatBillingAddress(address) {
    this.billingAddress = {
      country: this.countryCodes.find(item => item.countryName === address.addressCountry || item.countryCodeName === address.addressCountry).countryCodeName,
      city: address.addressTown,
      street: address.addressLine2,
      houseNumberOrName: address.addressLine1,
      stateOrProvince: address.addressCounty,
      postalCode: address.addressPostCode,
      geoCoord: this._customerLocationCoord
    };
    this.billingAddressValid = true;
  }

  getLatestCurrentBooking() {
    const currentAppState: AppState = this.getState(this._appStore);
    // current booking store vars
    this.currentBooking = currentAppState.currentBookingReducer.currentBooking;
    this._bookingCompleteFlag = this.currentBooking.bookingCompletion.bookingComplete;
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }


  getCopy() {
    const panelHeader = this._copyService.getCopyBySection(
      this._bookingCarrier,
      window.location.pathname.split('/')[2],
      ['panelHeader', this.flightDirection === 1 ? 'outbound' : 'inbound']
    );
    const termsAndConditionsCopy = this._copyService.getCopyBySection(
      this._bookingCarrier,
      window.location.pathname.split('/')[2],
      ['termsAndConditions']
    );

    const overView = this._copyService.getCopyBySection(
      'OTHER',
      'overview',
      [this.flightDirection === 1 ? 'outbound' : 'inbound']
    );

    this.appCopy = {
      termsAndConditions: termsAndConditionsCopy[0],
      panelHeader: { ...overView[0], ...panelHeader[0] }
    };
    console.log(overView, panelHeader);
  }

  getAirportCopy() {
    this.appAirportCopy = this._airportCopyService.getAirportsCopy();
  }

  // emitted data/functions from child components
  // phone validation
  handleValidatePhoneNumber(data) {
    this.phoneNumberValid = false;
    this._bookingService.validatePhoneNumber(data);
  }

  resetBottomForm() {
    const state = this.getState(this._appStore);
    const isLogin = state.userReducer.userDetails.userLoggedIn
    this._loginService.logout();
    this.bookerForm.form.reset();
    this.termsForm.form.reset();
    if (!isLogin && this.standardPaymentForm) {
      this.standardPaymentForm.form.reset();
    }
  }

  handleEmailInputChange() {
    const termsForm = typeof this.termsFormExpresscheckout !== 'undefined';
    if (termsForm && !this.termsFormExpresscheckout.form.valid) {
      const bookerEmail = this.bookerForm.form.value.bookerEmail === '';
      this.termsFormExpresscheckout.reset({
        hasSmsMarketingEnrolmentForExpress: bookerEmail
      });
    }
  }
  // newsletter checkbox
  customsForInspection(val: any) {
    this._bookingService.updateCustomsForInspection(val);

  }
  sendNewsLetterOptIn(value) {
    this._bookingService.updateNewsletterOptIn(value);
  }
  iUnderstand(val: any) {
    if (val.currentTarget.checked === true) {
      ga('send', 'event', 'Vanilla', 'Pay - Consent', 'Checked');
    }
  }

  iVerify(val: any) {
    if (val === true) {
      this._appStore.dispatch({ type: 'HAS_CUSTOMS_AGREEMENT', payload: true });
    } else {
      this._appStore.dispatch({ type: 'HAS_CUSTOMS_AGREEMENT', payload: false });
    }
  }
  skywardsCheck(val: any): void {
    this._bookingService.updateEmiratesSkywardsAcknowledgment(val)
  }
  // data checkbox
  sendDataSharingAllowed(value) {
    this._bookingService.updateDataSharingAllowed(value);
  }
  updateSmsMarketingReminder(value) {
    this._bookingService.updateSmsMarketingReminder(value);
  }
  updateSmsWhatsAppEnrolment(value) {
    this._bookingService.updateSmsWhatsAppEnrolment(value);
  }
  togglePayByInvoice(event) {
    this.payByInvoice = !this.payByInvoice;
  }
  // booker data to addBooking
  sendBookerToRequest(data) {
    this._bookingService.updateBooker(data);
  }
  // send amend data to api
  sendBookerToAmend() {
    if (this.bookingType === 'amend') {
      // Reaches the amend API without going through setPaymentType(), so mark
      // the popup in-flight here too (see handlePaymentSubmit()'s wrapper).
      this._paypalRedirectPopupInFlight = true;

      const amendData = {
        reference: this._bookingJourneyReference,
        flag: 64
      };
      this._bookingService.postAmend(amendData);
    }
  }

  cancelAmend() {
    this._router.navigate(['my-account/bookings/booking-details'],
      { queryParams: { ref: this.currentBooking.bookingReference } });
  }

  deleteSavedCard(value) {

    const modalData: ModalData = {
      type: 'default',
      modalType: 'deleteCard',
      title: this.appCopy.panelHeader['removeCardModalTitle' + this.selectedLanguage], //'Remove card?',
      content: this.appCopy.panelHeader['removeCardModalContent' + this.selectedLanguage], //'Are you sure you want to remove this card?',
      buttonText: this.appCopy.panelHeader['removeCardButton' + this.selectedLanguage], //'Yes, remove my card',
      cancelButtonText: this.appCopy.panelHeader['cancelRemoveCardButton' + this.selectedLanguage], //'No, keep my card',
      cardReference: value,
      userId: this.userDetails.currentUser.userId,
      userToken: this.userDetails.userToken
    };

    this._errorService.handleModal(modalData);

  }

  sendToPayment(data, forceRetry?) {

    let isRetry = false;

    if (data.payment.transactionType === 'Retry' || forceRetry) { isRetry = true; }

    this._bookingService.updateBookingFlagsBooking(true);
    this._bookingService.updatePayment(
      data.payment,
      data.promo,
      data.isCustomerService,
      data.billingAddress,
      this.bookingProduct,
      this.userDetails.userLoggedIn,
      isRetry,
      this.bookingType);

    this._dataStorageService.saveData();

    if (!isRetry) {
      this.sendFBPixelEvent();
    }
  }

  sendToPaymentAmend(data?) {
    const amendStoreItem = this.getState(this._appStore).currentBookingReducer.amendBooking;
    const amendData = {
      reference: this._bookingJourneyReference,
      flag: amendStoreItem.amendBookingFlag
    };

    this._bookingService.updatePaymentForAmends(data.payment, data.promo, data.isCustomerService, data.billingAddress, amendData);
  }

  // amend submit function
  handleBookerAmend() {
    if (this.phoneNumberValid) {
      this.showAmendLoader = true;
      this.paymenttype === 2 ? this.handlePaymentSubmit() : this.handlePaymentOptionSubmit();
    }
  }

  // amend payment submit function
  // See handlePaymentSubmit() - same abort-safety wrapper for the amend flow.
  handlePaymentAmend(manualCardPayment?: string) {
    this._paypalRedirectPopupInFlight = false;
    this.handlePaymentAmendInternal(manualCardPayment);
    if (!this._paypalRedirectPopupInFlight) {
      this._bookingService.closePaypalPopup();
    }
  }

  private handlePaymentAmendInternal(manualCardPayment?: string) {

    if (manualCardPayment === 'manualCardPayment') {
      // 'manualCardPayment' marks a click on the shared "Confirm and pay"
      // button, which now also submits PayPal (no separate PayPal button) -
      // set paymenttype from the selected option instead of forcing card.
      const isPaypalSubmit = this.selectedPaymentMethod === 'paypal';
      this.recievePaymentType(isPaypalSubmit ? 3 : 2);
      if (isPaypalSubmit) {
        // Must run synchronously in this click handler, before the
        // ADD_BOOKING round-trip, or the browser blocks the popup.
        this.preOpenPaypalRedirectPopup();
      }
    }
    const formHasStandardForm = typeof this.standardPaymentForm !== 'undefined';
    const formHasRecurringForm = typeof this.recurringPaymentForm !== 'undefined';

    this._applePayData = this._bookingService.getApplePaymentToken();

    if (this.paymenttype === 2 && formHasStandardForm && !this.standardPaymentForm.form.valid) {
      this._validationService.markFormDirty(this.standardPaymentForm.form);
      return;
    }

    if (this.paymenttype === 2 && formHasStandardForm && this.standardPaymentForm.billingAddressForm) {
      if (this.standardPaymentForm.billingAddressForm.form.valid) {
        const billingForm = this.standardPaymentForm.billingAddressForm.form.value;
        if (!this.validateBillingAddress(billingForm)) {
          return
        }
        this.formatBillingAddress(this.standardPaymentForm.billingAddressForm.locationData);
      } else {
        this.billingAddressValid = false;
        return;
      }
    }

    if (this.paymenttype === 2 && formHasRecurringForm && !this.recurringPaymentForm.form.valid) {
      this._validationService.markFormDirty(this.recurringPaymentForm.form);
      return;
    }

    if (this.paymenttype === 2 && formHasRecurringForm && this.recurringPaymentForm.billingAddressForm) {
      if (this.recurringPaymentForm.billingAddressForm.form.valid) {
        const billingForm = this.recurringPaymentForm.billingAddressForm.form.value;
        if (!this.validateBillingAddress(billingForm)) {
          return;
        }
        this.formatBillingAddress(this.recurringPaymentForm.billingAddressForm.locationData);
      } else {
        this.billingAddressValid = false;
        return;
      }
    }

    // Google Pay Data
    // this._googlePayData = this._bookingService.getGooglePaymentToken();
    // this.oldprice = this._bookingService.getOldPriceService();

    // if (this._paymentMethod === 0) {
    //   if (this.price.totalPrice.majorAmount > 0) {
    //     if (this._googlePayData == '') {
    //       const x = document.getElementById('googlepayValidation');
    //       x.style.display = "block";
    //       return;
    //     }

    //     if(this.price.totalPrice.majorAmount !== this.oldprice.totalPrice.majorAmount) {
    //       const y = document.getElementById('googlepayRefile');
    //       y.style.display = "block";
    //       return;
    //     }

    //   }
    // }

    this.setPaymentType(formHasStandardForm, formHasRecurringForm);

    this.showLoader = true;
    setTimeout(() => {
      this.showLoader = false;
    }, 6500);

  }

  // exponea function

  exponeaEvent(emailid) {
    let email_check: any = true;
    let sms_check: any = false;
    console.log('email', this.user.userDetails.currentUser.hasMarketingEnrolment);
    console.log('sms', this.user.userDetails.currentUser.hasSMSMarketingEnrolment);
    console.log('user in or not', this.user.userDetails.userLoggedIn);

    if (this.user.userDetails.userLoggedIn) {
      const emailCheck = this.bookerForm?.hasMarketingEnrolment ? this.bookerForm?.hasMarketingEnrolment : this.user.userDetails.currentUser.hasMarketingEnrolment;
      const emailSms = this.user.userDetails.currentUser.hasSMSMarketingEnrolment;

      if (emailCheck === true) {
        email_check = 'accept'
      } else {
        email_check = 'reject'
      }

      if (emailSms === true) {
        sms_check = 'accept'
      } else {
        sms_check = 'reject'
      }
    } else {
      // const emailCheck = this.bookerForm.form.controls['optOutMarketingEnrolment'].value;
      // need to update this code from model later after confirmation from kosta
      const emailSms = true;
      const emailCheck = this.bookerForm.form.value.hasSmsMarketingEnrolment;

      if (emailCheck === true) {
        email_check = 'accept'
      } else {
        email_check = 'reject'
      }

      if (emailSms === true) {
        sms_check = 'accept'
      } else {
        sms_check = 'reject'
      }

    }


    // const emailid = this.bookerForm.form.controls['bookerEmail'].value;
    exponea.identify({ 'email_id': emailid });
    console.log('EXPONEA: identify', emailid);

    const cc = this.bookerForm?.bookerData?.countryCode;
    const pn = this.bookerForm?.bookerData?.phoneNumber;
    const phone = cc && pn ? '+' + cc + pn : undefined;

    if (email_check === 'accept') {
      this._exponeaBanner.trackOptIn({
        category: 'email',
        email: emailid,
        phone,
        touchpoint: 'oldfunnel_payment',
      });
    } else {
      // retained opt-out event — payload unchanged from today
      fetch('https://api.ipify.org?format=json').then(results => results.json()).then(data => {
        exponea.track('consent', {
          'email_id': emailid,
          'action': email_check,
          'category': "email",
          'valid_until': 'unlimited',
          'ip': data.ip,
          'message': "Untick this box if you do not wish to be kept informed about special offers, new services and airline partners.",
          'touchpoint': "oldfunel_payment",
          entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
        })
      });
    }

    // SMS/WhatsApp — read the real checkbox, not the hardcoded sms_check derivation above
    if (this.bookerForm?.hasSmsWhatsAppEnrolment === true) {
      // one banner; Bloomreach fans out to consent(accept, sms) + consent(accept, whatsapp)
      this._exponeaBanner.trackOptIn({
        category: 'sms_whatsapp', email: emailid, phone,
        touchpoint: 'oldfunnel_payment',
      });
    } else {
      // no scenario on reject — fan out to both channels ourselves,
      // mirroring the email reject payload above
      fetch('https://api.ipify.org?format=json').then(results => results.json()).then(data => {
        ['sms', 'whatsapp'].forEach(category => {
          exponea.track('consent', {
            'email_id': emailid,
            'action': 'reject',
            'category': category,
            'valid_until': 'unlimited',
            'ip': data.ip,
            'message': "Untick if you do not want to receive news and special offers via SMS and/or WhatsApp",
            'touchpoint': "oldfunel_payment",
            entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
          });
        });
      });
    }
  }
  // main submit function
  // gets data from child components
  validateBillingAddress(billingForm) {
    if (billingForm.collectionAddressCountry.trim()
      && billingForm.collectionAddressCounty.trim()
      && billingForm.collectionAddressLine1.trim()
      && billingForm.collectionAddressLine2.trim()
      && billingForm.collectionAddressPostcode.trim()
      && billingForm.collectionAddressTown.trim()) {
      this.billingAddressValid = true;
      return true;
    } else {
      this.billingAddressValid = false;
      return false;
    }
  }

  handlePaymentSubmit() {
    this._paypalRedirectPopupInFlight = false;
    this.handlePaymentSubmitInternal();
    if (!this._paypalRedirectPopupInFlight) {
      this._bookingService.closePaypalPopup();
    }
  }

  private handlePaymentSubmitInternal() {
    if (this.bookingType === 'new') {
      this._appStore.dispatch({ type: 'UPDATE_MARKETING_ENROLMENT', payload: this.bookerForm.hasMarketingEnrolment });
    }

    const isPaypalSubmit = this.selectedPaymentMethod === 'paypal';
    this.recievePaymentType(isPaypalSubmit ? 3 : 2);
    if (isPaypalSubmit) {
      this.preOpenPaypalRedirectPopup();
      const isD2d = this.getState(this._appStore).bookingReducer.bookingDetails.isD2dService;
      if (isD2d && !this._bookingService.hasOpenPaypalPopup() && !this.hasReservationExpired()) {
        this._errorService.handleCustomError({
          text: 'Please allow pop-ups for this site to pay with PayPal, or select another payment method.',
          sticky: false
        });
        return;
      }
    }
    this.setCurrentStoreVars();
    this.handleEmailInputChange();

    const formHasStandardForm = typeof this.standardPaymentForm !== 'undefined';
    const formHasRecurringForm = typeof this.recurringPaymentForm !== 'undefined';

    const termsForm = typeof this.termsForm !== 'undefined';

    this._applePayData = this._bookingService.getApplePaymentToken();

    this.billingAddressValid = true;

    let bookerForm; // for apple pay & card payment
    let standardForm; // for card payment
    let recurringForm;// for card payment
    let billingForm; // for card payment
    let termsFormData; // for apple pay

    if (formHasStandardForm && this.standardPaymentForm.form.valid) {
      standardForm = this.standardPaymentForm.form.value;
    }
    if (formHasRecurringForm && this.recurringPaymentForm.form.valid) {
      recurringForm = this.recurringPaymentForm.form.value;
    }

    const bookerFormHasError = this._validationService.handleBookerValidation(this.bookerForm.form, this.bookerForm.bookerData, this.bookingType);

    if (termsForm && !this.termsForm.form.valid) {
      this._validationService.markFormDirty(this.termsForm.form);
      return;
    }

    if (formHasStandardForm && !this.standardPaymentForm.form.valid) {
      this._validationService.markFormDirty(this.standardPaymentForm.form);
      return;
    }

    if (formHasStandardForm && this.standardPaymentForm.billingAddressForm) {
      if (this.standardPaymentForm.billingAddressForm.form.valid) {
        const billingForm = this.standardPaymentForm.billingAddressForm.form.value;
        if (!this.validateBillingAddress(billingForm)) {
          return
        }
        this.formatBillingAddress(this.standardPaymentForm.billingAddressForm.locationData);
      } else {
        this.billingAddressValid = false;
        return;
      }
    }

    if (formHasRecurringForm && !this.recurringPaymentForm.form.valid) {
      this._validationService.markFormDirty(this.recurringPaymentForm.form);
      return;
    }

    if (formHasRecurringForm && this.recurringPaymentForm.billingAddressForm) {
      if (this.recurringPaymentForm.billingAddressForm.form.valid) {
        const billingForm = this.recurringPaymentForm.billingAddressForm.form.value;
        if (!this.validateBillingAddress(billingForm)) {
          return;
        }
        this.formatBillingAddress(this.recurringPaymentForm.billingAddressForm.locationData);
      } else {
        this.billingAddressValid = false;
        return;
      }
    }

    // Google Pay Data
    // this._googlePayData = this._bookingService.getGooglePaymentToken();
    // this.oldprice = this._bookingService.getOldPriceService();

    // if (this._paymentMethod === 0) {
    //   if (this.price.totalPrice.majorAmount > 0) {
    //     if (this._googlePayData == '') {
    //       const x = document.getElementById('googlepayValidation');
    //       x.style.display = "block";
    //       return;
    //     }

    //     if (this.price.totalPrice.majorAmount !== this.oldprice.totalPrice.majorAmount) {
    //       const y = document.getElementById('googlepayRefile');
    //       y.style.display = "block";
    //       return;
    //     }

    //   }
    // }

    const bookingDetails = this.bookingState.bookingDetails;
    const params = this._activatedRoute.parent.snapshot.data['bookingProduct'];
    const modalData: ModalData = {
      type: 'default',
      modalType: 'timeSlotExpried',
      title: this.appCopy.panelHeader[(params === 'abc' ? bookingDetails.isD2dService ? 'd2dTimeslotExpiredTitle' : 'abcTimeslotExpiredTitle' : bookingDetails.isD2dService ? 'd2dTimeslotExpiredTitle' : 'ccdTimeslotExpiredTitle') + this.selectedLanguage],
      content: this.appCopy.panelHeader[(params === 'abc' ? bookingDetails.isD2dService ? 'd2dTimeslotExpiredContent' : 'abcTimeslotExpiredContent' : bookingDetails.isD2dService ? 'd2dTimeslotExpiredContent' : 'ccdTimeslotExpiredContent') + this.selectedLanguage],
      buttonText: this.appCopy.panelHeader[(params === 'abc' ? bookingDetails.isD2dService ? 'd2dTimeslotExpiredButton' : 'abcTimeslotExpiredButton' : bookingDetails.isD2dService ? 'd2dTimeslotExpiredButton' : 'ccdTimeslotExpiredButton') + this.selectedLanguage],
      showLoader: false,
    };

    // this time duration should be 30 and 15 before live updates
    if (this.hasReservationExpired()) {
      this._bookingService.closePaypalPopup();
      this._errorService.handleModal(modalData);
      return;
    }
    if (!bookerFormHasError) {
      const d2dReducer = this.getState(this._appStore).d2dReducer;
      termsFormData = this.termsForm ? this.termsForm.form.value : '';
      bookerForm = this.bookerForm.form.value;
      if (d2dReducer.addBookingCount === 0 && this.bookingType !== 'amend') {
        this._appStore.dispatch({
          type: 'SAVE_FORM_DATA', payload: {
            bookerForm: bookerForm,
            standardForm: standardForm,
            recurringForm: recurringForm,
            billingForm: billingForm,
            billingFormData: this.billingAddress,
            termsFormData: termsFormData
          }
        });
      }
      this.sendBookerToRequest(this.bookerForm.bookerData);

      // if booking type is amend
      // send to api
      if (this.bookingType === 'amend') {
        this.sendBookerToAmend();
      } else {
        // continue to payment...
        this._appLoaderService.showLoader(this.appCopy.panelHeader['bookingRefTitle' + this.selectedLanguage] + ' = ' + this.bookingState.bookingDetails.bookingReference);

        this.checkNewUser();

        this.setPaymentType(formHasStandardForm, formHasRecurringForm);
      }
    } else {
      this.showAmendLoader = false;
    }

    this.exponeaEvent(this.bookerForm.bookerData.emailAddress);

  }

  handlePaymentOptionSubmit() {
    if (this.bookingType === 'new') {
      this._appStore.dispatch({ type: 'UPDATE_MARKETING_ENROLMENT', payload: this.bookerForm.hasMarketingEnrolment });
    }
    this.setCurrentStoreVars();

    const formHasStandardForm = typeof this.standardPaymentForm !== 'undefined';
    const formHasRecurringForm = typeof this.recurringPaymentForm !== 'undefined';

    const termsForm = typeof this.termsFormExpresscheckout !== 'undefined';

    this._applePayData = this._bookingService.getApplePaymentToken();


    let bookerForm; // for apple pay & card payment
    let standardForm; // for card payment
    let recurringForm;// for card payment
    let billingForm; // for card payment
    let termsFormDataCheckoutExpress; // for apple pay


    // validate booker form and booking contact form
    // pass in form and form data
    // send errors back to ui

    if (termsForm && !this.termsFormExpresscheckout.form.valid) {
      this._validationService.markFormDirty(this.termsFormExpresscheckout.form);
      return;
    }

    const bookingDetails = this.bookingState.bookingDetails;
    const params = this._activatedRoute.parent.snapshot.data['bookingProduct'];
    const modalData: ModalData = {
      type: 'default',
      modalType: 'timeSlotExpried',
      title: this.appCopy.panelHeader[(params === 'abc' ? bookingDetails.isD2dService ? 'd2dTimeslotExpiredTitle' : 'abcTimeslotExpiredTitle' : bookingDetails.isD2dService ? 'd2dTimeslotExpiredTitle' : 'ccdTimeslotExpiredTitle') + this.selectedLanguage],
      content: this.appCopy.panelHeader[(params === 'abc' ? bookingDetails.isD2dService ? 'd2dTimeslotExpiredContent' : 'abcTimeslotExpiredContent' : bookingDetails.isD2dService ? 'd2dTimeslotExpiredContent' : 'ccdTimeslotExpiredContent') + this.selectedLanguage],
      buttonText: this.appCopy.panelHeader[(params === 'abc' ? bookingDetails.isD2dService ? 'd2dTimeslotExpiredButton' : 'abcTimeslotExpiredButton' : bookingDetails.isD2dService ? 'd2dTimeslotExpiredButton' : 'ccdTimeslotExpiredButton') + this.selectedLanguage],
      showLoader: false,
    };

    // this time duration should be 30 and 15 before live updates
    if (this.hasReservationExpired()) {
      this._bookingService.closePaypalPopup();
      this._errorService.handleModal(modalData);
      return;
    }

    const d2dReducer = this.getState(this._appStore).d2dReducer;
    termsFormDataCheckoutExpress = this.termsFormExpresscheckout ? this.termsFormExpresscheckout.form.value : '';
    bookerForm = this.bookerForm.form.value;
    if (d2dReducer.addBookingCount === 0 && this.bookingType !== 'amend') {
      this._appStore.dispatch({
        type: 'SAVE_FORM_DATA', payload: {
          bookerForm: bookerForm,
          standardForm: standardForm,
          recurringForm: recurringForm,
          billingForm: billingForm,
          billingFormData: this.billingAddress,
          termsFormData: termsFormDataCheckoutExpress
        }
      });
    }
    let bookerDataExpressCheckout;
    let countrycode;
    const googlePayData = this._bookingService.getGooglePaymentToken();
    if (this.paymenttype === 0 && googlePayData) {
      console.log(googlePayData)
      const fullName = googlePayData.shippingAddress.name;
      const nameParts = fullName.split(" ");
      const firstName = nameParts[0];
      const lastName = nameParts.slice(1).join(" ");
      const parsedPhoneNumber = this._loginService.parsePhoneNumber(googlePayData.shippingAddress.phoneNumber);
      exponea.identify({ 'email_id': googlePayData.email });
      console.log(`exponea: identify user with google payment token`);
      COUNTRY_CODES.all.find((item) => {
        if (item.countryCodeName === googlePayData.shippingAddress.countryCode) {
          console.log('item.countryName', item.countryName);
          countrycode = item.countryCode
        }
      });
      bookerDataExpressCheckout = {
        countryCode: parsedPhoneNumber.countryCode ? parsedPhoneNumber.countryCode : countrycode,
        emailAddress: googlePayData.email,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: parsedPhoneNumber.phone
      }
    }
    const applePayData = this._bookingService.getApplePaymentToken();
    if (this.paymenttype === 1 && applePayData) {
      console.log('data send to booker before add booking api', applePayData)
      const lastName = applePayData.shippingContact.familyName;
      const firstName = applePayData.shippingContact.givenName;
      const parsedPhoneNumber = this._loginService.parsePhoneNumber(applePayData.shippingContact.phoneNumber);
      exponea.identify({ 'email_id': applePayData.shippingContact.emailAddress });
      console.log(`exponea: identify user with apple payment token`, applePayData.shippingContact.emailAddress);
      COUNTRY_CODES.all.find((item) => {
        if (item.countryName === applePayData.shippingContact.country) {
          console.log('item.countryName', item.countryName);
          countrycode = item.countryCode
        }
      });
      console.log(parsedPhoneNumber.phone, 'countryCode', countrycode);
      bookerDataExpressCheckout = {
        countryCode: parsedPhoneNumber.countryCode ? parsedPhoneNumber.countryCode : countrycode,
        emailAddress: applePayData.shippingContact.emailAddress,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: parsedPhoneNumber.phone
      }
    }
    // PayPal has no express-checkout prefill: Adyen's PayPal component only
    // hands back state.data (an opaque payment payload, not shopper contact
    // info) via onSubmit, and no separate server-side authorize call exists
    // in this app's design to source payer name/email/phone from. PayPal
    // customers fill the booker form manually, same as a card payment.
    // If this ever changes (e.g. the backend can echo shopper info back
    // from ADD_BOOKING's Adyen call), reinstate a paymenttype === 3 branch
    // here mirroring apple/google, and add paypalData back to the `if`
    // below - but note getPaypalPaymentToken() now returns a raw JSON
    // string (Adyen's state.data), not a PaypalPaymentResult object, so
    // the fields read here (payerEmail/payerFirstName/etc.) would need to
    // come from wherever that echoed shopper info actually lands instead.
    // const paypalData = this._bookingService.getPaypalPaymentToken();
    // if (this.paymenttype === 3 && paypalData) {
    //   console.log('data send to booker before add booking api', paypalData);
    //   exponea.identify({ 'email_id': paypalData.payerEmail });
    //   console.log(`exponea: identify user with paypal payment token`, paypalData.payerEmail);
    //   const parsedPhoneNumber = this._loginService.parsePhoneNumber(paypalData.payerPhone);
    //   bookerDataExpressCheckout = {
    //     countryCode: parsedPhoneNumber.countryCode,
    //     emailAddress: paypalData.payerEmail,
    //     firstName: paypalData.payerFirstName,
    //     lastName: paypalData.payerLastName,
    //     phoneNumber: parsedPhoneNumber.phone
    //   };
    // }
    console.log('bookerDataExpressCheckout', bookerDataExpressCheckout);
    if (applePayData || googlePayData) {
      this.sendBookerToRequest(bookerDataExpressCheckout);
    } else {
      this.sendBookerToRequest(this.bookerForm.bookerData);
    };




    // if booking type is amend
    // send to api
    if (this.bookingType === 'amend') {
      this.sendBookerToAmend();
    } else {
      // continue to payment...
      this._appLoaderService.showLoader(this.appCopy.panelHeader['bookingRefTitle' + this.selectedLanguage] + ' = ' + this.bookingState.bookingDetails.bookingReference);

      // this.sendUserEmail();

      this.setPaymentType(formHasStandardForm, formHasRecurringForm);
    }

    // no need to send exponea event ExpressCheckout case

    // this.exponeaEvent(bookerDataExpressCheckout.emailAddress);

  }

  useSavedCard() {
    // let thisCard = null;
    this._encryptedData = '';
    this._savedCardDetails = this.userCards.find(x => x.recurringDetailReference === this._recurringReference);
    this._maskedNumber = this._savedCardDetails.number;
    const currentBooking = this.getState(this._appStore).currentBookingReducer.currentBooking;
    let collectionCity = '';
    if (currentBooking.bookingJourney) {
      collectionCity = currentBooking.bookingJourney[0].collectionLocation.addressTown;
    }

    if (this._useSavedCard) {
      if (this._savedCardDetails.hasBillingAddress) {
        const savedAddress = JSON.parse(JSON.stringify(this._savedCardDetails.billingAddress));
        if (!this._savedCardDetails.billingAddress.addressTown) {
          savedAddress.addressTown = collectionCity;
        }
        this.formatBillingAddress(savedAddress);
      } else {
        this.billingAddress = null;
        this.billingAddressValid = true;
      }
      this._appStore.dispatch({ type: 'CARD_TYPE', payload: this._savedCardDetails.cardType });
      this._appStore.dispatch({ type: 'PAYMENT_WITH_SAVED_CARD', payload: true });
    }
    this.callApi();
  }

  logDisabledConditions() {
    // console.group('Payment Button Disabled Conditions:');
    // console.log('disableBook:', this.disableBook);
    // console.log('phoneNumberValid:', this.phoneNumberValid);
    // console.log('virtualBags === 0:', this.virtualBags === 0);

    // if (this.standardPaymentForm) {
    //   console.log('standardPaymentForm form valid:', this.standardPaymentForm.form?.valid);
    //   if (this.standardPaymentForm.billingAddressForm) {
    //     console.log('standardPaymentForm billing address valid:', this.standardPaymentForm.billingAddressForm.form?.valid);
    //   }
    // }

    // if (this.recurringPaymentForm) {
    //   console.log('recurringPaymentForm form valid:', this.recurringPaymentForm.form?.valid);
    //   if (this.recurringPaymentForm.billingAddressForm) {
    //     console.log('recurringPaymentForm billing address valid:', this.recurringPaymentForm.billingAddressForm.form?.valid);
    //   }
    // }
    // console.groupEnd();
  }

  private setPaymentType(formHasStandardForm, formHasRecurringForm) {

    // Past every validation guard - the payment request is going out, so a
    // pre-opened PayPal popup must stay open for the redirect.
    this._paypalRedirectPopupInFlight = true;

    // check to see if user has a selected card item
    // and if saved card is true
    // this comes from the recurring payment form
    // wallet payments (google 0 / apple 1 / paypal 3) must never pick up
    // saveCard / useSavedCard off the recurring card form
    if (formHasRecurringForm && this.paymenttype !== 1 && this.paymenttype !== 0 && this.paymenttype !== 3) {
      this._saveCard = this.recurringPaymentForm.form.value.saveCard === '' ? false : this.recurringPaymentForm.form.value.saveCard;
      this._useSavedCard = typeof this.recurringPaymentForm.selectedCardItem !== 'undefined' && this.recurringPaymentForm.selectedCardItem !== '' && this.recurringPaymentForm.selectedCardItem !== 'newCard';
    } else {
      this._useSavedCard = false;
    }

    // if standard form check to see if save card is true
    if (formHasStandardForm) {
      this._saveCard = this.standardPaymentForm.form.value.saveCard === '' ? false : this.standardPaymentForm.form.value.saveCard;
    }

    // if user is paying by invoice or CS overrides payment
    // skip card encryption
    if ((this.eligibleForInvoice && this.payByInvoice) || (this.bookingType === 'amend' && this.overridePayment) || this.paymenttype === 1 || this.paymenttype === 0 || this.paymenttype === 3) { // for apple payments
      this.callApi();
    } else if (this._useSavedCard) {
      this._recurringReference = this.recurringPaymentForm.selectedCardItem;
      this.useSavedCard();
      // if(this._paymentMethod !== 0) {
      // this.useSavedCard();
      // }
    } else {
      let data = null;
      if (formHasStandardForm) {
        data = this.standardPaymentForm.form.value;
      } else if (formHasRecurringForm) {
        data = this.recurringPaymentForm.form.value;
      } else {
        data = {};
      }

      const obscuredCardNumber = data.ccnumber ? data.ccnumber[0] : 0;
      let cardType = ''
      if (obscuredCardNumber) {
        cardType = cardTypes[obscuredCardNumber];
      }
      this._appStore.dispatch({ type: 'CARD_TYPE', payload: cardType });
      this._appStore.dispatch({ type: 'PAYMENT_WITH_SAVED_CARD', payload: false });
      this.encryptMyData(data);
    }
  }

  private sendUserEmail() {
    console.log('payment method', this.paymenttype);
    if (this.paymenttype === 1) {
      const data = this._bookingService.getApplePaymentToken();
      console.log('apple pay data token', data);
      const newUser = {
        emailAddress: data.shippingContact.emailAddress,
      };

      this._appStore.dispatch({ type: 'UPDATE_NEW_USER', payload: newUser });
    }
    if (this.paymenttype === 0) {
      const data = this._bookingService.getGooglePaymentToken();
      console.log('google pay data token', data);
      const newUser = {
        emailAddress: data.email
      };
      this._appStore.dispatch({ type: 'UPDATE_NEW_USER', payload: newUser });
    }
    // getPaypalPaymentToken() now returns Adyen's raw state.data as a JSON
    // string, not a PaypalPaymentResult object - there is no payerEmail to
    // read (see the booker-prefill comment above handlePaymentOptionSubmit's
    // `if (applePayData || googlePayData)` for the full explanation). This
    // method's only call site is already commented out elsewhere in this
    // file, so it has no runtime effect either way.
    // if (this.paymenttype === 3) {
    //   const data = this._bookingService.getPaypalPaymentToken();
    //   console.log('paypal data token', data);
    //   const newUser = {
    //     emailAddress: data.payerEmail
    //   };
    //   this._appStore.dispatch({ type: 'UPDATE_NEW_USER', payload: newUser });
    // }


  }

  private checkNewUser() {
    // if user has set a password, save it and login
    if (typeof this.bookerForm.form.controls['setPassword'] !== 'undefined' && this.bookerForm.form.controls['setPassword'].value !== '') {

      const newUser = {
        emailAddress: this.bookerForm.form.controls['bookerEmail'].value,
        password: btoa(this.bookerForm.form.controls['setPassword'].value)
      };

      this._appStore.dispatch({ type: 'UPDATE_NEW_USER', payload: newUser });
      this._appStore.dispatch({ type: 'UPDATE_CUSTOMER_HAS_MARKETING_ENROLMENT', payload: true });
    }
  }

  // encrypt card data
  private encryptMyData(value) {
    this._dt = new Date();

    if (this.price.totalPrice.majorAmount !== 0 && this.paymenttype !== 0 && this.paymenttype !== 1 && this.bookingAmendType !== 'refund') {
      this._cardData = {
        number: value.ccnumber.toString().replace(/\s+/g, ''),
        cvc: value.CardSecurityCode.toString(),
        holderName: value.nameoncard.toString(),
        expiryMonth: value.ccexpmonth.toString(),
        expiryYear: '20' + value.ccexpyear.toString(),
        generationtime: this._dt
      };
    } else {
      this._cardData = {
        number: '',
        cvc: '',
        holderName: '',
        expiryMonth: '',
        expiryYear: '',
        generationtime: ''
      };
    }

    const _cseInstance = adyen.encrypt.createEncryption(this._key, this._options);
    this._encryptedData = _cseInstance.encrypt(this._cardData);
    this._maskedNumber = this.price.totalPrice.majorAmount === 0 ? '' : this._cardData.number.replace(/.(?=.{4,}$)/g, '*');
    this.callApi();
  }

  // check for errors
  // then form request to send to booking service
  private callApi() {

    const requestData = {
      payment: null,
      promo: null,
      isCustomerService: false,
      billingAddress: this.billingAddress
    };

    // skip 3DS check if admin booking/amend
    if (this.isCustomerSupport) {
      requestData.billingAddress = null;
    }

    const bookingMinorPrice = parseInt(this.price.totalPrice.minorAmount, 10);
    const fullBookingPrice = parseInt(this.price.pricingResponse[0].pricingBreakdown.totalPriceMinor, 10);
    if (this.paymenttype === 0 || this.paymenttype === 1 || this.paymenttype === 3) { // for apple pay, google pay & paypal
      this._encryptedData = 'false'
    }
    // console.log('encryptedData', !this._encryptedData, 'price', this.price.totalPrice.majorAmount !== 0 , 'save card', !this._useSavedCard, 'invoice', !this.payByInvoice, 'overridepayment', !this.overridePayment);
    // if adyen returns false
    // show invalid card error toast message
    if (!this._encryptedData && this.price.totalPrice.majorAmount !== 0 && !this._useSavedCard && !this.payByInvoice && !this.overridePayment && this.bookingAmendType !== 'refund') {
      // return;
      this.disableBook = false;
      this._appLoaderService.hideLoader();
      const error = {
        text: "Invalid card number. Please try again or contact <a href='mailto:support@portr.com'>support@portr.com</a>",
        sticky: true
      };
      this._errorService.handleCustomError(error);
      return;
    }


    // Google Pay Data
    this._googlePayData = this._bookingService.getGooglePaymentToken();

    // Apple Pay Data
    this._applePayData = this._bookingService.getApplePaymentToken();
    this._applePayToken = ''; // reset this token

    const tokenFields = buildPaymentTokenFields(this.paymenttype, {
      googlePayData: this._googlePayData,
      applePayData: this._applePayData
    });

    if (this.paymenttype === 0) {
      if (this._googlePayData != '') {
        // Google Pay Token
        this._googlePayToken = tokenFields.googlePayToken;
        // Google Pay Card Number
        this._googlePayMaskNumber = this._googlePayData.paymentMethodData.info.cardDetails;
        // businessTransactionType
        this._transactionType = 'New';
        this._businessTransactionType = 'NewBusiness';
      }

      this._useSavedCard = false;
    } else if (this.paymenttype === 1) {
      if (this._applePayData != null) {
        // Apple Pay Token
        this._applePayToken = tokenFields.applePayToken;
        // businessTransactionType
        this._transactionType = 'New';
        this._businessTransactionType = 'NewBusiness';
      }

      this._useSavedCard = false;
    } else if (this.paymenttype === 3) {
      // businessTransactionType
      this._transactionType = 'New';
      this._businessTransactionType = 'NewBusiness';

      this._useSavedCard = false;
    } else {
      this._googlePayToken = '';
      this._googlePayMaskNumber = this._maskedNumber;
      // businessTransactionType
      this._transactionType = 'New';
      this._businessTransactionType = 'NewBusiness';
    }

    const currencyCode = this.getState(this._appStore).timeslotReducer.currency.code;
    const paymentRequest: PaymentRequest = {
      bookingReference: this.bookingState.bookingDetails.bookingReference,

      obscuredCardNumber: this._googlePayMaskNumber,
      googlePayToken: this._googlePayToken,
      applePayToken: this._applePayToken,
      paymenttype: this.paymenttype,
      encodedCardInformation: this._encryptedData,
      amount: bookingMinorPrice,
      fullAmount: fullBookingPrice,
      quoteId: this.price.quoteId,
      transactionType: this._transactionType,
      businessTransactionType: this._businessTransactionType,
      currency: currencyCode,

      isPaidByInvoice: this.payByInvoice,
      saveCard: this._saveCard,

      hasBillingAddress: this._useSavedCard ? this._savedCardDetails.hasBillingAddress : false,
      recurringReference: this._recurringReference === '' ? null : this._recurringReference,
    }
      ;

    let promoRequest = {};
    let promo = {
      promotType: this.price.promotionRewardType ?? 0,
      promoAmount: this.price.promotionRewardAmount
    };

    this._appStore.dispatch({ type: 'PROMO_DETAILS', payload: promo });

    if (this._promoActive) {
      promoRequest = {
        promoCode: this.price.promoCodesApplied[0],
        promoDiscountAmount: this._promoDiscount
      };
      ga('send', 'event', 'Promo Code Used', this.price.promoCodesApplied[0]);
    } else {
      promoRequest = {};
    }

    if (this.bookingType !== 'amend') {
      if (typeof this.bookerForm.form.controls['hasSmsMarketingEnrolment'] !== 'undefined') {
        const hasSmsMarketingEnrolment = this.bookerForm.form.controls['hasSmsMarketingEnrolment'].value;

        if (this.paymenttype !== 2) {
          this.sendNewsLetterOptIn(this.hasSmsMarketingEnrolmentForExpressCheckout);
          this.updateSmsMarketingReminder(this.hasSmsMarketingEnrolmentForExpressCheckout);
        } else {
          this.sendNewsLetterOptIn(hasSmsMarketingEnrolment);
          this.updateSmsMarketingReminder(hasSmsMarketingEnrolment);
        }

      } else {
        this.sendNewsLetterOptIn(true);
        this.updateSmsMarketingReminder(true);
      }

      if (typeof this.bookerForm.form.controls['hasSmsWhatsAppEnrolment'] !== 'undefined') {
        const hasSmsWhatsAppEnrolment = this.bookerForm.form.controls['hasSmsWhatsAppEnrolment'].value;

        if (this.paymenttype !== 2) {
          this.updateSmsWhatsAppEnrolment(this.hasSmsMarketingEnrolmentForExpressCheckout);
        } else {
          this.updateSmsWhatsAppEnrolment(hasSmsWhatsAppEnrolment);
        }

      } else {
        this.updateSmsWhatsAppEnrolment(true);
      }
    }

    this.sendDataSharingAllowed(true);

    this.getLatestCurrentBooking();

    const csMoto = this.getState(this._appStore).flightFinderReducer.csMotoFromUrl;
    // if payment or booking amend
    // set correct transaction type
    // call amend booking
    if ((this.bookingState.bookingDetails.bookingAmendType === 'payment' || this.bookingState.bookingDetails.bookingAmendType === 'refund') && this.bookingType === 'amend') {

      if (this.overridePayment) {
        paymentRequest.transactionType = 'OverridePayment';
        paymentRequest.amount = 0;
      } else {
        paymentRequest.transactionType = 'Amendment';
        paymentRequest.amount = this._priceHistoryMinor;
        paymentRequest.googlePayToken = this._googlePayToken;
      }
      paymentRequest.businessTransactionType = this.bookingState.bookingDetails.bookingAmendType === 'payment' ? 'Amendment' : 'Refund';
      paymentRequest.fullAmount = this._priceHistoryMinor;
      requestData.payment = paymentRequest;
      requestData.promo = promoRequest;
      requestData.isCustomerService = csMoto;

      this.disableBook = true;
      if (this.getState(this._appStore).bookingReducer.bookingDetails.bookingAmendPaymentFailed) {
        this.sendToPayment(requestData, true);
      } else {
        this.sendToPaymentAmend(requestData);
      }

    } else {
      // if adding payment to completed booking
      // DON'T call addBooking..
      // call makePayment
      if (this._bookingCompleteFlag) {
        // booking complete - payment failed
        paymentRequest.transactionType = 'Retry';
        requestData.payment = paymentRequest;
        requestData.promo = promoRequest;
        requestData.isCustomerService = csMoto;
        this.sendToPayment(requestData);
      } else {
        // new payment request
        paymentRequest.transactionType = this._transactionType;
        requestData.payment = paymentRequest;
        requestData.promo = promoRequest;
        requestData.isCustomerService = csMoto;
        this.sendToPayment(requestData);
      }

      this.disableBook = true;

    }

  }

  // conversion tracking - external
  sendFBPixelEvent() {
    const flightData = this.getState(this._appStore).flightReducer.flightDetails.flightResponse.flightStatusDetails[0];
    const direction = this.getState(this._appStore).flightReducer.flightDetails.flightResponse.flightDirection === 1 ? 'Out' : 'In';
    const price = this.price.totalPrice.majorAmount;
    const bookingProduct = this.bookingProduct.toUpperCase() + (this.bookingProduct === 'ccd' ? direction : '');
    const departureAirport = flightData.departureAirport.airportCode;
    const arrivalAirport = flightData.arrivalAirport.airportCode;
    const airlineCode = flightData.operatingAirlineCode;
    const departureDate = moment(flightData.departureDateTimeDetails.scheduledDate).format('DD/MM/YYYY');
    const bookingRef = this.bookingState.bookingDetails.bookingReference;
    const bags = this.bookingState.bookingDetails.virtualBagCount;

    fbq('track', 'Purchase', {
      currency: 'GBP',
      value: price,
      content_category: bookingProduct,
      content_type: 'product',
      content_ids: [
        departureAirport,
        airlineCode,
        departureDate
      ],
      contents: [{
        id: bookingRef,
        quantity: bags
      }]
    });
  }


  handleThreeDSIframeEvent(e) {
    if ((e.origin === this.threeDS2Data.originURL || e.origin === this.threeDs1Data.notificationUrl) && e.data.resultCode) {
      if (e.data.resultCode === 'ChallengeShopper') {
        // remove identifyShopper iframe if it exists
        const iframe = document.getElementsByClassName('threeDSMethodIframeClass')[0];

        if (iframe) {
          document.getElementById('threedsContainer').removeChild(iframe);
        }

        // do ChallengeShopper
        const data = {
          serverTransID: e.data.challengeThreeDSServerTransID,
          acsTransID: e.data.acsTransID,
          messageVersion: e.data.messageVersion,
          acsURL: e.data.acsURL,
          originURL: this.threeDS2Data.originURL
        };

        this._bookingService.initiateChallengeShopper(data);
        this._sharedService.challengeShopperSubject$.next(true);
      } else if (e.data.resultCode === 'Authorised') {

        if (this.bookingType === 'amend') {
          this._bookingService.handleAmendSuccess();
        } else {
          this._bookingService.handleBookingSuccess();
        }

      } else if (e.data.resultCode === 'Refused' || e.data.resultCode === 'Cancelled') {
        this.showChallengeShopper = false;
        this._appStore.dispatch({ type: 'RESET_3DS_STATE' });
        this._bookingService.closePaypalPopup(true);
        this._appLoaderService.hideLoader();
        if (this._threedsContainer && this._threedsIframe) {
          this._threedsContainer.removeChild(this._threedsIframe);
        }
        this._sharedService.challengeShopperSubject$.next(false);

        const error = {
          text: e.data.resultCode === 'Cancelled' ? 'Payment was cancelled.' : 'Payment was refused. Please check your payment details and try again.',
          sticky: false
        };
        this._errorService.handleCustomError(error);
      }
    }

  }

  handleApplePay(e) {
    if (this.bookingType === 'new') {
      this.setCurrentStoreVars();
    }

    const termsForm = typeof this.termsFormExpresscheckout !== 'undefined';

    this.billingAddressValid = true;

    // const bookerFormHasError = this._validationService.handleBookerValidation(this.bookerForm.form, this.bookerForm.bookerData);

    if (termsForm && !this.termsFormExpresscheckout.form.valid) {
      this._validationService.markFormDirty(this.termsFormExpresscheckout.form);
      return;
    }

    // initialize apple payment
    console.log(`initializing apple payment`)

    this.applePayForm.onApplePay();


  }

  // True on the second leg of a D2D booking, which autoBookingSubmit() sends
  // from a timer with no user interaction.
  private isD2dAutoSubmitBooking(): boolean {
    const state = this.getState(this._appStore);
    return state.bookingReducer.bookingDetails.isD2dService
      && state.d2dReducer.addBookingCount === 1;
  }

  // True when the timeslot/plan reservation has run out, using the same
  // thresholds as the timeSlotExpried modal guards in handlePaymentSubmit()
  // and handlePaymentOptionSubmit() (30 mins for D2D, 15 otherwise; amends
  // never expire). Extracted so the PayPal popup can be suppressed *before*
  // it opens rather than orphaned when those guards return.
  private hasReservationExpired(): boolean {
    if (this.bookingType === 'amend') { return false; }

    const bookingDetails = this.bookingState.bookingDetails;
    const duration = moment.duration(moment().diff(bookingDetails.autoRefreshTime));

    return bookingDetails.isD2dService
      ? duration.asMinutes() >= 30
      : duration.asMinutes() >= 15;
  }

  // Opens the PayPal placeholder popup via BookingService, which owns the
  // window reference so it survives the D2D product switch (that navigation
  // destroys this component). Must run synchronously in the click handler,
  // before the ADD_BOOKING round-trip, or the browser blocks the popup.
  //
  // Skips opening when the reservation has already expired - the submit is
  // about to abort at the timeSlotExpried modal guard.
  private preOpenPaypalRedirectPopup(): void {
    if (!isPlatformBrowser(this.platformId)) { return; }
    if (this.hasReservationExpired()) { return; }
    this._bookingService.openPaypalPlaceholderPopup();
  }

  // The popup is gone before the redirect could happen. On a D2D booking the
  // first leg already exists server-side, so surface this instead of retrying.
  private handlePaypalPopupAbandoned(): void {
    this._bookingService.closePaypalPopup(true);
    this._appLoaderService.hideLoader();
    this._errorService.handleCustomError({
      text: 'The PayPal window was closed before your payment was completed. Please try again or select another payment method.',
      sticky: false
    });
  }

  // Sends the popup to PayPal once ADD_BOOKING's redirect response arrives.
  // BookingService holds the window reference, so on a D2D booking this works
  // even though the popup was opened by a previous instance of this component
  // (before goToBookingSwitcher() destroyed it).
  private openPaypalRedirectPopup(): void {
    // The customer closed the popup while the booking request was in flight. The
    // screen stayed blocked so they couldn't re-submit mid-creation; now that the
    // response is here, release it and tell them the payment didn't go through.
    // Deliberately NOT redirecting - in a new popup or this tab - because that
    // would override their cancellation.
    if (this._bookingService.wasPaypalPopupCancelled()) {
      this.handlePaypalPopupAbandoned();
      return;
    }

    if (!this.threeDs1Data.issueUrl) {
      console.error('PayPal redirect: no redirect URL (issuerUrl) in the response');
      this._bookingService.closePaypalPopup(true);
      this._appLoaderService.hideLoader();
      this._errorService.handleCustomError({
        text: 'We could not start the PayPal redirect. Please try again or select another payment method.',
        sticky: false
      });
      return;
    }

    if (this._bookingService.navigatePaypalPopup(this.threeDs1Data.issueUrl)) {
      return;
    }

    // No usable popup. Two very different situations:
    //
    //  - It was opened and the customer then closed it: they cancelled, so
    //    hijacking their tab to PayPal is the opposite of what they asked for.
    //    Report it and let them retry.
    //  - It never opened (browser blocked it): they never expressed any intent
    //    to cancel, so for a single booking fall back to a same-tab redirect
    //    rather than dead-ending a payment whose booking already exists.
    //    (D2D can't do this - it would unload the app mid-flow and strand the
    //    first leg - so it fails before submitting; see handlePaymentSubmit.)
    const wasOpened = this._bookingService.wasPaypalPopupOpened();
    const isD2d = this.getState(this._appStore).bookingReducer.bookingDetails.isD2dService;

    if (wasOpened || isD2d) {
      this.handlePaypalPopupAbandoned();
      return;
    }

    window.location.assign(this.threeDs1Data.issueUrl);
  }

  handleApplePayComplete() {
    this.recievePaymentType(1);
    if (this.bookingType === 'amend') {
      this.handlePaymentAmend();
    } else {
      this.handlePaymentOptionSubmit();
      // this.handlePaymentSubmit();
      console.log('handle apple pay submint to call add booking');
    }

  }

  goPanelBack() {
    this._eventsService.goToPanel('prev');
  }

  milesLoginRedirect() {
    let lastStatus = this.milesLoaded;
    this.milesLoaded = 'loading';
    this._dataStorageService.saveDataPromise()
      .then(res => {
        this.milesLoaded = lastStatus;
        if (res) {
          const anchorTag = document.createElement('a');
          const milesLink = `${this.milesLoginUrl}&lang=${this.languageCode}&redirect_uri=${this.callbackURL}`
          anchorTag.setAttribute('href', milesLink);
          anchorTag.hidden = true;
          document.body.appendChild(anchorTag);
          anchorTag.click();
        } else {
          this._errorService.handleCustomError({
            text: 'Miles login failed, please try again',
            sticky: false
          })
        }
      });
  }

  scrollToPromoField() {
    this.togglePromo = true;
    new Promise((resolve) => {
      setTimeout(() => {
        resolve('');
      }, 10);
    }).then(() => {
      const promoField = document.getElementById('PromoCode');
      promoField.scrollIntoView({ behavior: 'smooth' });
    });
  }

  autoBookingSubmit() {
    const state = this.getState(this._appStore);
    const milesReducer = state.milesAndMoreReducer;
    let timer;
    if (state.bookingReducer.bookingDetails.isD2dService && state.d2dReducer.addBookingCount === 1) {
      // remove promo if it was applied on timeslot screen but removed in other booking
      if (state.d2dReducer.promoCode.length === 0) {
        this._appStore.dispatch({ type: 'REMOVE_PROMO', payload: [] });
      }
      this._appStore.dispatch({ type: 'REFRESH_PRICE_OBJECT' });
      timer = setTimeout(async () => {
        if (milesReducer.milesRedeemed && milesReducer.milesVerified?.status === 'AUTHORIZED') {
          try {
            const price: any = await this._pricingService.getPricePromise();
            let milesDiscount = 0;
            if (price.pricingResponse && price.pricingResponse[0]) {
              milesDiscount = price.pricingResponse[0].pricingBreakdown.milesDiscountMinor
            }
            const state = this.getState(this._appStore);
            const request = {
              bookingReference: state.bookingReducer.bookingDetails.bookingReference,
              transactionId: state.milesAndMoreReducer.payByMilesResponse.transactionId,
              transactionStatus: 1,
              milesDiscount: milesDiscount
            };
            const res = await this._milesAndMoreService.amendMcheckoutStatusPromise(request);
            if (res === 'error') {
              await this._pricingService.getPricePromise();
            }
            this.paymenttype === 2 ? this.handlePaymentSubmit() : this.handlePaymentOptionSubmit();
          } catch (e) {
            console.log(e);
          }
        } else {
          if (this.showLoader) {
            clearTimeout(timer);
            this.autoBookingSubmit();
            return;
          }
          this.paymenttype === 2 ? this.handlePaymentSubmit() : this.handlePaymentOptionSubmit();
        }
      }, 2500);
    }
  }

  ngAfterViewInit(): void {
    const d2dReducer = this.getState(this._appStore).d2dReducer;
    // need to get new quote id in case of d2d primary booking
    this.isD2dService = this.getState(this._appStore).bookingReducer.bookingDetails.isD2dService;
    if (this.isD2dService && d2dReducer.addBookingCount === 1) {
      this._pricingService.getPrice();
      // set payment type standard/recurring or Apple pay
      this.paymenttype = d2dReducer.paymentType;
    }
    console.log('setting payment type from reducer for d2d booking', d2dReducer.paymentType)


    this.autoBookingSubmit();
  }

  ngOnDestroy() {
    this._appStore.dispatch({ type: 'RESET_3DS_STATE' });
    if (this._bookingInitSubscription) { this._bookingInitSubscription.unsubscribe(); }
    if (this._userSubscription) { this._userSubscription.unsubscribe(); }
    if (this._priceSubscription) { this._priceSubscription.unsubscribe(); }
    if (this._bookingStateSubscription) { this._bookingStateSubscription.unsubscribe(); }
    if (this._validatePhoneNumberSubscription) { this._validatePhoneNumberSubscription.unsubscribe(); }
    if (this._cardDeletedSubscription) { this._cardDeletedSubscription.unsubscribe(); }
    if (this._updatedUserSubscription) { this._updatedUserSubscription.unsubscribe(); }
    if (this._userLoggedInSubscription) { this._userLoggedInSubscription.unsubscribe(); }
    if (this._userLoggedOutSubscription) { this._userLoggedOutSubscription.unsubscribe(); }
    if (this._loaderSubscription) { this._loaderSubscription.unsubscribe(); }
    if (this._cardDeletedRequestSentSubscription) { this._cardDeletedRequestSentSubscription.unsubscribe(); }
    if (this._stateSubscription) { this._stateSubscription.unsubscribe(); }
    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe(); }
    if (this._amendBookingCallSub) { this._amendBookingCallSub.unsubscribe(); }
    if (this._d2dBookingSubscription) { this._d2dBookingSubscription.unsubscribe(); }
    if (this._upsellBookingSubscription) { this._upsellBookingSubscription.unsubscribe(); }
    if (this._applePaymentSubmitSubscription) { this._applePaymentSubmitSubscription.unsubscribe(); }
    if (this._paypalPopupAbandonedSubscription) { this._paypalPopupAbandonedSubscription.unsubscribe(); }
    if (this._milesStateSubscription$) { this._milesStateSubscription$.unsubscribe(); }
    if (this._priceStatusSubscription$) { this._priceStatusSubscription$.unsubscribe(); }
    if (this._milesSubscription) { this._milesSubscription.unsubscribe(); }
    if (this._flybackReducerSubscription) { this._flybackReducerSubscription.unsubscribe(); }
    if (this._verifyEmailSubscription) { this._verifyEmailSubscription.unsubscribe(); }
    if (isPlatformBrowser(this.platformId)) {
      this._externalScriptsService.removeScript("apple-pay-js");
      // Close any PayPal popup left over from leaving this screen (e.g. back to
      // timeslots). The one exception - the D2D product switch, where the popup
      // must stay open for the second booking's redirect - is handled inside
      // BookingService, which owns the window reference.
      this._bookingService.handlePaymentScreenLeft();
    }
  }

}
